// tslint:disable:max-line-length
export const REDIRECT_ES = {
'/blog/cocer-patatas-tiempo-de-coccion-perfecto-patata' : '/blog/articulo/cocer-patatas-tiempo-de-coccion-perfecto-de-la-patata/938/938',
'/recetas/pescado-al-horno-facil-y-rapido' : '/recetas/r/pescado-al-horno-facil-y-rapido/esgp010',
'/recetas/alcachofas-al-horno' : '/recetas/r/alcachofas-al-horno/esgp006',
'/blog/como-cocer-judias-verdes-en-3-sencillos-pasos' : '/blog/articulo/como-cocer-judias/941/941',
'/recetas/receta-de-pionono-salado' : '/recetas/r/pionono-salado/esgp016',
'/blog/5-tips-para-rebajar-el-exceso-de-picante-en-una-comida' : '/blog/articulo/5-tips-para-rebajar-el-exceso-de-picante-en-una-comida/942/942',
'/recetas/guisantes-con-jamon-receta-sencilla' : '/recetas/r/guisantes-con-jamon-receta-sencilla/esgp011',
'/blog/berenjenas-rellenas-ideas-preparar-receta' : '/blog/articulo/berenjenas-rellenas-ideas-para-preparar-esta-receta/991/991',
'/blog/tarta-de-manzana-recetas-sin-hojaldre-sin-gluten' : '/blog/articulo/tarta-de-manzana-recetas-faciles-sin-hojaldre-y-sin-gluten/1360/1360',
'/borraja' : '/desde-1853/campo-hasta-plato/borraja-que-es-propiedades-y-beneficios/943/943',
'/blog/7-ideas-fantasticas-de-cenas-saludables' : '/blog/articulo/cenas-saludables-mas-de-10-ideas-fantasticas/947/947',
'/blog/patata-asada-5-formas-de-preparar-esta-receta' : '/blog/articulo/patata-asada-5-formas-de-preparar-esta-receta/1361/1361',
'/puerro' : '/desde-1853/campo-hasta-plato/el-puerro-un-sabor-esencial/806/152',
'/recetas/receta-de-verduras-a-la-mantequilla' : '/recetas/r/verduras-a-la-mantequilla/esgp013',
'/blog/champinones-al-horno-recetas-para-preparar-en-20-minutos' : '/blog/articulo/champinones-al-horno-recetas-para-preparar-en-20-minutos/989/989',
'/batata' : '/desde-1853/campo-hasta-plato/batata/1362/1362',
'/recetas/huevos-revueltos-con-champinones-laminados' : '/recetas/r/huevos-revueltos-con-champinones-laminados/esgp015',
'/recetas/pasta-con-brocoli-y-crema' : '/recetas/r/pasta-con-brocoli-y-crema/esgp034',
'/nabo' : '/desde-1853/campo-hasta-plato/el-nabo-menudo-olvidado-y-sin-embargo-tan-crujiente/800/148',
'/blog/tortilla-de-patatas-recetas-rapidas-deliciosas' : '/blog/articulo/tortilla-de-patatas-recetas-rapidas-y-deliciosas-de-este-plato-unico/1281/1281',
'/blog/beneficios-del-apio-descubre-5-beneficios-para-tu-salud' : '/blog/articulo/beneficios-del-apio-descubre-5-beneficios-para-tu-salud/995/980',
'/repollo' : '/desde-1853/campo-hasta-plato/el-repollo-todo-sobre-esta-verdura/784/98',
'/blog/los-pimientos-cuanto-tiempo-hay-que-cocinarlos' : '/blog/articulo/los-pimientos-cuanto-tiempo-hay-que-cocinarlos/944/944',
'/blog/pollo-al-horno-sencillo-nutritivo' : '/blog/articulo/pollo-al-horno-un-plato-sencillo-y-nutritivo/1363/1363',
'/remolacha' : '/desde-1853/campo-hasta-plato/la-remolacha-un-bien-saludable/777/96',
'/recetas/pat-sii-iu-noodles-con-salsa-de-soja-y-pollo' : '/blog/recetas/pat-sii-iu-noodles-con-salsa-de-soja-y-pollo/esgp018',
'/blog/sopas-de-verduras-sabrosas-y-faciles-de-preparar' : '/blog/articulo/como-hacer-sopa-de-verduras-facil-y-sabrosas/1230/1230',
'/maiz' : '/desde-1853/campo-hasta-plato/el-maiz-un-vegetal-que-se-come-de-un-bocado/796/145',
'/patata' : '/desde-1853/campo-hasta-plato/la-patata-uno-de-los-alimentos-mas-consumidos-en-espana/794/111',
'/blog/coliflor-rebozada-recetas-familia' : '/blog/articulo/coliflor-rebozada-recetas-para-toda-la-familia/1282/1282',
'/blog/3-recetas-con-brocoli' : '/blog/articulo/3-recetas-con-brocoli-que-van-hacer-que-adores-este-alimento/1278/1278',
'/recetas/pasta-al-horno-un-toque-de-queso' : '/blog/articulo/pasta-al-horno-un-toque-de-queso/1377/1377',
'/recetas/revuelto-de-ajetes-tiernos-y-champinones' : '/recetas/r/revuelto-de-ajetes-tiernos-y-champinones/esgp030',
'/blog/vitamina-b12-propiedades-alimentos-encontrarla' : '/blog/articulo/vitamina-b12-propiedades-y-en-que-alimentos-encontrarla/1378/1378',
'/blog/merluza-en-salsa-verde-recetas-faciles-cocina' : '/blog/articulo/merluza-en-salsa-verde-diferentes-variantes-para-esta-sencilla-receta/1283/1283',
'/blog/como-cocinar-verduras-al-microondas-y-no-morir-en-el-intento' : '/blog/articulo/como-cocinar-verduras-al-microondas-y-no-morir-en-el-intento/945/945',
'/blog/ensalada-de-arroz-recetas-sanas-rapidas-y-sencillas' : '/blog/articulo/ensalada-de-arroz-recetas-sanas-rapidas-y-sencillas-de-preparar-0/1379/1379',
'/blog/recetas-crema-de-calabacin-todos-los-gustos' : '/blog/articulo/recetas-de-crema-de-calabacin-casera-y-light-para-todos-los-gustos-0/1376/1376',
'/blog/recetas-crepes-dulce-salados' : '/blog/articulo/deliciosas-recetas-de-crepes-dulces-y-salados/1367/1367',
'/blog/como-hacer-bechamel-maizena' : '/blog/articulo/como-hacer-bechamel-con-maizena-0/1366/1366',
'/rabano' : '/desde-1853/campo-hasta-plato/el-rabano-una-planta-con-multiples-beneficios/808/155',
'/recetas/almejas-en-salsa-verde' : '/recetas/r/almejas-en-salsa-verde/esgp009',
'/blog/5-comidas-rapidas-para-triunfar-seguro' : '/blog/articulo/5-comidas-rapidas-y-sanas-para-triunfar-seguro/952/952',
'/blog/recetas-arepas-maiz' : '/blog/articulo/recetas-de-arepas-de-maiz/1380/1380',
'/blog/aceite-de-maiz-propiedades-contraindicaciones' : '/blog/articulo/aceite-de-maiz-propiedades-y-contraindicaciones/1285/1285',
'/blog/recetas-de-bizcocho-con-harina-de-espelta' : '/blog/articulo/recetas-de-bizcocho-con-harina-de-espelta/1381/1381',
'/champinones' : '/desde-1853/campo-hasta-plato/la-patata-uno-de-los-alimentos-mas-consumidos-en-espana/794/111',
'/blog/condimentos-aportan-sabor-verduras' : '/blog/articulo/que-condimentos-aportan-mas-sabor-tus-platos-de-verduras/953/953',
'/blog/pan-maiz-alternativa-deliciosa' : '/blog/articulo/pan-de-maiz-una-alternativa-deliciosa/1382/1382',
'/blog/comida-tailandesa-recetas-para-hacer-en-casa' : '/blog/articulo/comida-tailandesa-recetas-para-hacer-en-casa/946/946',
'/judias-verdes' : '/desde-1853/campo-hasta-plato/la-judia-verde-perfecta-para-platos-frios-y-calientes/791/106',
'/blog/habas-guisadas-5-recetas-cocina-faciles-almorzar' : '/blog/articulo/habas-guisadas-5-recetas-faciles/1383/1383',
'/blog/verduras-propiedades' : '/blog/articulo/que-verduras-contienen-un-mayor-aporte-de-propiedades-0/1384/1384',
'/pimiento' : '/desde-1853/campo-hasta-plato/el-pimiento-una-verdura-muy-colorida/809/153',
'/recetas/pizza-al-horno-con-las-manos-en-la-masa' : '/blog/articulo/pizza-al-horno-con-las-manos-en-la-masa/1385/1385',
'/cebolla' : '/desde-1853/campo-hasta-plato/la-cebolla-una-planta-excelente-para-la-salud/802/149',
'/recetas/ensalada-mixta' : '/blog/articulo/ensalada-mixta/1386/1386',
'/blog/salsa-de-maiz-dulce-como-la-preparamos' : '/blog/articulo/salsa-de-maiz-dulce-como-la-preparamos/949/949',
'/recetas/ensalada-con-pollo-la-cena-perfecta-para-despues-de-fiestas' : '/recetas/r/ensalada-con-pollo/esgp050',
'/recetas/pasta-con-salsa-de-berenjena' : '/recetas/r/pasta-con-salsa-de-berenjena/esgp020',
'/blog/7-buenos-habitos-alimenticios-para-ninos' : '/blog/articulo/7-buenos-habitos-alimenticios-para-ninos/948/948',
'/guisantes' : '/desde-1853/campo-hasta-plato/los-guisantes-para-consumir-sin-moderacion/805/151',
'/hinojo' : '/desde-1853/campo-hasta-plato/hinojo/1368/1368',
'/pepino' : '/desde-1853/campo-hasta-plato/el-pepino-descubrelo/785/100',
'/blog/tortitas-y-crepes-con-maicena' : '/blog/articulo/tortitas-y-crepes-con-maicena/1387/1387',
'/recetas/patatas-guisadas-con-verduras' : '/blog/articulo/patatas-guisadas-con-verduras/1388/1388',
'/calendario-verduras' : '/blog/novedades',
'/blog/5-especias-para-verduras-que-no-pueden-faltar-en-tu-cocina' : '/blog/articulo/5-especias-para-verduras-que-no-pueden-faltar-en-tu-cocina/994/994',
'/blog/champinones-recetas-sencillas-cenar' : '/blog/articulo/httpsbonduelleesblogchampinones-recetas-sencillas-cenar/1288/1288',
'/berro' : '/desde-1853/campo-hasta-plato/berro/1370/1370',
'/blog/como-hacer-masa-madre-espelta' : '/blog/articulo/como-hacer-masa-madre-de-espelta/1389/1389',
'/cardo' : '/desde-1853/campo-hasta-plato/cardo/1371/1371',
'/recetas/ensalada-crujiente-de-cous-cous' : '/recetas/r/ensalada-crujiente-de-cous-cous/esgp021',
'/blog/consumo-verduras-ninos' : '/blog/articulo/la-importancia-del-consumo-de-verduras-en-los-ninos/951/951',
'/blog/habas-secas-recetas-de-cocina-y-propiedades' : '/blog/articulo/habas-secas-recetas-de-cocina-y-propiedades/1286/1286',
'/soja' : '/desde-1853/campo-hasta-plato/soja/1372/1372',
'/acelga' : '/desde-1853/campo-hasta-plato/acelga/1373/1373',
'/blog/ensalada-rusa-origen-recetas-del-mundo' : '/blog/articulo/ensalada-rusa-origen-y-recetas-en-diferentes-partes-del-mundo/1390/1390',
'/blog/beneficios-de-masticar-bien-los-alimentos' : '/blog/articulo/beneficios-de-masticar-bien-los-alimentos/992/967',
'/verduras/acedera' : '/desde-1853/campo-hasta-plato/acedera/1374/1374',
'/endibia' : '/desde-1853/campo-hasta-plato/endibia/1375/1375',
'/recetas/ensalada-de-pimientos-asados' : '/recetas/r/ensalada-de-pimientos-asados/esgp059',
'/recetas/pizza-de-verduras' : '/recetas/r/pizza-de-verduras/esgp104',
'/blog/recetas-quinoa-pollo' : '/blog/articulo/recetas-con-quinoa-y-pollo/1391/1391',
'/blog/maicena-harina-fecula-maiz-perfecta-celiacos' : '/blog/articulo/maicena-la-harina-de-fecula-de-maiz-perfecta-para-los-celiacos/1392/1392',
'/blog/recetas-faciles-de-cocinar-5-recetas-en-5-minutos' : '/blog/articulo/recetas-faciles-de-cocinar-5-recetas-en-5-minutos/997/997',
'/blog/propiedades-salsa-de-soja-recetas' : '/blog/articulo/propiedades-de-la-salsa-de-soja-y-diferentes-recetas/1393/1393',
'/blog/recetas-crema-pastelera-con-maicena' : '/blog/articulo/recetas-de-crema-pastelera-con-maicena/1394/1394',
'/blog/quinoa-para-cenar-recetas-sencillas' : '/blog/articulo/quinoa-para-cenar-dos-recetas-sencillas/1395/1395',
'/lechuga' : '/desde-1853/campo-hasta-plato/la-lechuga-lo-mas-apreciado-para-hacer-una-ensalada/798/120',
'/blog/propiedades-espelta-tiene-gluten' : '/blog/articulo/propiedades-de-la-espelta-tiene-gluten/1396/1396',
'/calabaza' : '/desde-1853/campo-hasta-plato/calabaza/1410/1410',
'/recetas/ensalada-de-frutos-rojos-con-salsa-de-mostaza-y-miel' : '/blog/articulo/ensalada-de-frutos-rojos-con-salsa-de-mostaza-y-miel/1397/1397',
'/blog/almejas-a-la-marinera-recetas-faciles-y-rapidas' : '/recetas/r/almejas-en-salsa-verde/esgp009',
'/recetas/tarta-de-zanahoria-y-nueces' : '/recetas/r/tarta-de-zanahoria-y-nueces/esgp007',
'/blog/3-recetas-galletas-espelta' : '/blog/articulo/3-recetas-de-galletas-de-espelta/1398/1398',
'/recetas/lentejas-al-curry-y-verduras' : '/recetas/r/lentejas-al-curry-y-verduras/esgp025',
'/blog/maiz-en-conserva-ventajas-comer-maiz-en-lata' : '/blog/articulo/maiz-en-conserva-todas-las-ventajas-de-comer-maiz-en-lata/1404/1404',
'/recetas/verduras-gratinadas' : '/recetas/r/verduras-gratinadas/esgp041',
'/recetas/revuelto-de-esparragos-y-champinones' : '/recetas/r/revuelto-de-esparragos-y-champinones/esgp027',
'/blog/las-mejores-ensalada-de-espanaen-tu-cocina' : '/blog/articulo/las-mejores-ensalada-de-espanaen-tu-cocina/993/993',
'/blog/la-cocina-moderna-y-de-vanguardia' : '/blog/articulo/la-cocina-moderna-y-de-vanguardia/1015/1015',
'/zanahoria' : '/desde-1853/campo-hasta-plato/la-zanahoria-una-verdura-para-todas-las-estaciones/782/97',
'/blog/quinoa-propiedades-recetas-superalimento' : '/blog/articulo/quinoa-propiedades-y-recetas-de-este-superalimento/1405/1405',
'/blog/recetas-crema-de-calabacin-casera-light' : '/blog/articulo/recetas-de-crema-de-calabacin-casera-y-light-para-todos-los-gustos-0/1376/1376',
'/blog/bonduelle-te-ensena-las-verduras-ricas-en-hierro' : '/blog/articulo/bonduelle-te-ensena-las-verduras-ricas-en-hierro/1292/1292',
'/blog/recetas-de-alcachofas-guisadas-3-platos-faciles-de-preparar' : '/blog/articulo/recetas-de-alcachofas-guisadas-3-platos-faciles-de-preparar/1411/1411',
'/blog/la-olla-express-como-la-usamos' : '/blog/articulo/la-olla-express-como-la-usamos/1027/1027',
'/blog/lentejas-recetas-chorizo-vegetarianas' : '/blog/articulo/lentejas-recetas-tradicionales-con-chorizo-o-vegetarianas/1412/1412',
'/blog/kiwi-amarillo-verde-recetas-propiedades-fruta-exotica' : '/blog/articulo/kiwi-amarillo-o-verde-recetas-y-propiedades-de-esta-fruta-exotica/1026/1026',
'/recetas/vermicelli-con-verduras-y-gambas' : '/recetas/r/vermicelli-con-verduras-y-gambas/esgp057',
'/berenjena' : '/desde-1853/campo-hasta-plato/la-berenjena-una-verdura-generosa/813/158',
'/coliflor' : '/desde-1853/campo-hasta-plato/la-coliflor-elijela-correctamente-y-preparala-bien/783/99',
'/blog/vitaminas-verduras' : '/blog/articulo/descubre-que-vitaminas-puedes-encontrar-en-las-verduras/1014/1014',
'/blog/que-es-semola-maiz' : '/blog/articulo/que-es-la-semola-de-maiz/1414/1414',
'/blog/como-guardar-las-patatas-peladas' : '/blog/articulo/como-guardar-las-patatas-peladas/1018/958',
'/blog/3-sencillas-recetas-sopa-quinoa' : '/recetas/recetas-por-tema/entrantes-y-sopas',
'/recetas/puerros-gratinados-con-bechamel-y-jamon' : '/recetas/r/puerros-gratinados-con-bechamel-y-jamon/esgp029',
'/recetas/copa-de-ensalada-de-aguacate-con-salmon-ahumado-y-huevo-duro' : '/recetas/r/copa-de-ensalada-de-aguacate-con-salmon-ahumado-y-huevo-duro/esgp024',
'/recetas/pizza-con-maiz-una-comida-para-cenar-que-tambien-puede-ser-sana' : '/recetas/recetas-por-tema/plato-principal/verduras/maiz',
'/blog/judias-verdes-rehogadas-preparacion-recetas' : '/recetas/verduras/judias-verdes',
'/recetas/verduras-al-papillote-una-receta-sana' : '/recetas/r/verduras-al-papillote-una-receta-sana/esgp026',
'/blog/tapas-recetas-faciles-cocina' : '/recetas/aperitivo-tapa',
'/blog/hamburguesas-caseras-recetas-sencillas-saludables' : '/recetas/r/hamburguesa-de-quinoa-espinacas-y-zanahoria/esgp035',
'/recetas/verduras-al-wok-con-espaguetis' : '/recetas/r/verduras-al-wok-con-espaguetis/esgp052',
'/recetas/hamburguesa-de-quinoa-espinacas-y-zanahoria-2' : '/recetas/r/hamburguesa-de-quinoa-espinacas-y-zanahoria/esgp035',
'/blog/5-beneficios-del-tomate-que-no-sabias-para-tus-hijos' : '/desde-1853/campo-hasta-plato/el-tomate-rico-en-vitaminas-b-y-c/803/150',
'/recetas/pastel-de-coliflor-patata-y-manzana-sobre-lecho-de-tomate-y-cebolla' : '/recetas/r/pastel-de-coliflor-patata-y-manzana-sobre-lecho-de-tomate-y-cebolla/esgp046',
'/recetas/ensalada-de-apio-fresco-manzana-y-zanahoria' : '/recetas/recetas-por-tema/ensalada/verduras/zanahorias',
'/blog/cual-es-la-mejor-forma-de-conservar-nuestras-sopas-y-pures' : '/blog/articulo/cual-es-la-mejor-forma-de-conservar-nuestras-sopas-y-pures/1024/1024',
'/recetas/tom-yum-sopa-de-langostinos-picante' : '/recetas/r/tom-yum-sopa-de-langostinos-picante/esgp071',
'/recetas/ensalada-de-arroz-con-verduras' : '/recetas/r/ensalada-de-arroz-con-verduras/esgp023',
'/blog/diversidad-alimentaria-segun-culturas' : '/blog/tendencias',
'/blog/podemos-dar-comida-picante-a-ninos-pequenos' : '/blog/tendencias',
'/recetas/salmon-al-horno-con-salsa-de-mostaza-y-miel' : '/recetas/r/salmon-al-horno-con-salsa-de-mostaza-y-miel/esgp037',
'/ajo' : '/desde-1853/campo-hasta-plato/el-ajo-un-alimento-muy-bueno-para-la-salud/817/817',
'/blog/recetas-arroz-quinoa' : '/recetas/r/ensalada-de-arroz-basmati/esgp049',
'/blog/parrillada-de-verduras-a-la-plancha-trucos-infalibles' : '/blog/alimentacion',
'/productos/guisantes-al-natural-muy-finos' : '/productos/p/guisantes-tiernos-y-muy-finos-sin-azucares-anadidos/03083681105605',
'/recetas/tarta-de-zanahoria-vegana' : '/recetas/r/tarta-de-zanahoria-y-nueces/esgp007',
'/blog/4-recetas-con-habas-verdes-para-sorprender-en-cualquier-ocasion' : '/recetas/verduras/habas',
'/blog/diversidad-alimentaria' : '/blog/tendencias',
'/blog/que-es-jarabe-sirope-maiz' : '/blog/tendencias',
'/recetas/ensalada-de-quinoa-con-tomate-brocoli-y-un-toque-de-maiz' : '/recetas/r/ensalada-de-quinoa-con-tomate-brocoli-y-un-toque-de-maiz/esgp100',
'/blog/beneficios-de-la-zanahoria-razones-comer-alimento' : '/desde-1853/campo-hasta-plato/la-zanahoria-una-verdura-para-todas-las-estaciones/782/97',
'/recetas/receta-de-musaka-de-verduras' : '/recetas/r/musaka-de-verduras/esgp012',
'/blog/champinones-rellenos-4-recetas-para-horno-en-menos-de-20min' : '/recetas/verduras/champinones',
'/espinaca' : '/desde-1853/campo-hasta-plato/las-espinacas-una-fuente-de-energia-0/825/102',
'/brocoli' : '/productos/verduras/brocoli',
'/blog/escaldar-tomates-para-pelarlos' : '/blog/articulo/escaldar-tomates-para-pelarlos/1017/1017',
'/apio' : '/productos/verduras/apio',
'/blog/bizcocho-de-yogur-recetas-cocina-reposteria' : '/recetas/r/bizcocho-integral-de-zanahoria/esgp054',
'/recetas/ensalada-corazones-de-alcachofa-con-queso-fresco' : '/recetas/r/ensalada-de-corazones-de-alcachofa-con-queso-fresco/esgp064',
'/recetas/ensalada-de-pimientos-del-piquillo-con-cebolla-caramelizada' : '/recetas/r/ensalada-de-pimientos-del-piquillo-con-cebolla-caramelizada/esgp036',
'/productos/maiz-dulce' : '/productos/p/bonduelle-maiz-dulce-sin-azucares-anadidos-lata-140-g.-individual/08410375110228',
'/blog/brownie-recetas-tipicas-sin-gluten-veganos-chocolate-blanco' : '/recetas/r/bizcocho-de-remolacha-y-chocolate/esgp101',
'/blog/guisantes-con-chorizo-recetas-y-como-prepararlos-en-4-pasos' : '/recetas/r/guisantes-con-jamon-receta-sencilla/esgp011',
'/blog/recetas-tabule-quinoa' : '/recetas/r/burger-vegetal-con-tabule-de-quinoa/esgp083',
'/recetas/pad-thai-fideos-fritos-con-gambas' : '/recetas/r/pad-thai-fideos-fritos-con-gambas/esgp031',
'/recetas/brocoli-con-calabaza-al-horno' : '/recetas/r/brocoli-con-calabaza-al-horno/esgp048',
'/blog/pan-quinoa-como-hacerlo-casa' : '/blog/recetas/hamburguesa-de-quinoa-espinacas-y-zanahoria/esgp035',
'/blog/como-debemos-preparar-nuestras-ensalada-para-llevar' : '/recetas/recetas-por-tema/ensalada',
'/recetas/bizcocho-de-remolacha-y-chocolate' : '/recetas/r/bizcocho-de-remolacha-y-chocolate/esgp101',
'/blog/parrillada-de-verduras-cuales-son-las-mejores-verduras-y-como-las-preparamos' : '/recetas/r/verduras-gratinadas/esgp041',
'/blog/comida-asiatica-para-hacer-en-casa-la-ultima-moda-en-gastronomia' : '/blog/articulo/comida-asiatica-para-hacer-en-casa-la-ultima-moda-en-gastronomia/1022/1022',
'/blog/4-trucos-para-aprovechar-el-agua-de-la-coccion-de-las-verduras' : '/blog/tendencias',
'/blog/recetas-de-judias-verdes-salteadas-sencillos-pasos' : '/recetas/verduras/judias-verdes',
'/blog/kefir-propiedades-recetas-caseras-probiotico' : '/blog/tendencias',
'/recetas/bizcocho-integral-de-zanahoria' : '/recetas/r/bizcocho-integral-de-zanahoria/esgp054',
'/recetas/ensalada-de-arroz-con-atun-y-verduras-2' : '/recetas/ensalada',
'/blog/6-recetas-de-verduras-para-cenar' : '/blog/articulo/6-recetas-de-verduras-para-cenar/1025/1025',
'/blog/leche-espelta-propiedades-receta' : '/blog/alimentacion',
'/blog/quinoa-roja-propiedades-recetas' : '/blog/alimentacion',
'/blog/jengibre-propiedades-recetas-especia' : '/blog/alimentacion',
'/blog/desayunos-copos-espelta' : '/blog/alimentacion',
'/blog/ensalada-light-verano' : '/recetas/ensalada',
'/recetas/gallo-cocido-con-pimiento-cebolla-y-guisantes-2' : '/recetas/r/gallo-cocido-con-pimiento-cebolla-y-guisantes/esgp065',
'/productos' : '/productos',
'/alcachofa' : '/recetas/verduras/alcachofas',
'/blog/recetas-con-maiz-dulce-alimento-saludable-platos' : '/recetas',
'/blog/zumos-de-verduras-recetas-sanas-para-el-verano' : '/blog/tendencias',
'/blog/4-utensilios-de-cocina-que-no-sabes-usar' : '/blog/tendencias',
'/blog/berenjenas-salteadas-con-que-podemos-acompanarlas' : '/recetas/verduras/berengenas',
'/verduras/esparragos-trigueros' : '/productos/verduras/esparragos',
'/recetas/tortilla-con-champinones-espinacas-y-cebolla' : '/recetas/r/tortilla-con-champinones-espinacas-y-cebolla/esgp074',
'/blog/verduras-de-color-rojo-que-beneficios-reportan-a-nuestra-salud' : '/blog/tendencias',
'/recetas/ensalada-de-atun-aguacate-y-edamame' : '/recetas/r/ensalada-de-atun-aguacate-y-edamame/esgp053',
'/recetas/albondigas-de-atun' : '/recetas',
'/verduras/berza' : '/desde-1853/campo-hasta-plato',
'/verduras/col' : '/desde-1853/campo-hasta-plato',
'/productos/macedonia-de-legumbres' : '/productos/p/bonduelle-macedonia-de-legumbres-lata-130-g.-pack-3/08410375110839',
'/recetas/salmon-con-verduras-perfecta-receta-para-una-cena-ligera' : '/recetas',
'/verduras/lombarda' : '/desde-1853/campo-hasta-plato',
'/blog/verduras-de-color-verde-beneficios-salud' : '/blog/tendencias',
'/recetas/ensalada-tropical-de-maiz' : '/recetas',
'/recetas/lasagna-de-carne-y-espinacas' : '/recetas/verduras/espinacas',
'/recetas/ensalada-de-pasta-con-verduras-y-atun' : '/recetas/r/ensalada-de-pasta-con-verduras-y-atun/esgp058',
'/recetas/tacos-de-pollo-con-maiz' : '/recetas',
'/blog/que-significa-ser-vegetariano' : '/blog/tendencias',
'/recetas/quinoa-con-berenjenas-y-tomates-cherry' : '/recetas/r/quinoa-con-berenjenas-y-tomates-cherry/esgp045',
'/recetas/segundos' : '/recetas/plato-principal',
'/verduras/habas' : 'Múltiples opciones',
'/recetas/ensalada-de-pasta-con-maiz' : '/recetas/r/ensalada-de-pasta-con-maiz/esgp066',
'/recetas/patatas-rellenas-de-verduras-y-jamon' : '/recetas/verduras/patatas',
'/recetas/souffle-de-espinacas-con-queso' : '/recetas/verduras/espinacas',
'/recetas/receta-de-galletas-saladas-de-maiz' : '/recetas/r/galletas-saladas-de-maiz/esgp051',
'/blog/sorprendentes-recetas-copos-de-maiz' : '/recetas/verduras/maiz',
'/blog/recetas-de-bizcochos-veganos' : '/recetas/postre',
'/blog/pelar-las-habas' : '/blog/tendencias',
'/blog/ensalada-de-primavera-7-recetas-de-ensalada' : '/recetas/ensalada',
'/blog/edamame-que-es-descubre-sus-beneficios' : '/productos/verduras/edamame',
'/recetas/chop-suey-de-verduras-con-pollo' : '/recetas',
'/recetas/cocinero-sofisticado' : '/blog/tendencias',
'/blog/10-primeros-platos-para-navidad' : '/recetas/plato-principal',
'/blog/recetas-de-pasta-vegetal-platos-saludables-faciles' : '/recetas',
'/blog/zumos-de-remolacha-verduras-recetas' : '/blog/tendencias',
'/blog/que-son-los-tacos-mexicanos-y-como-podemos-prepararlos' : '/recetas',
'/recetas/habas-con-jamon-2' : '/recetas/r/habas-con-jamon/esgp070',
'/blog/ensalada-de-maiz-5-ideas-para-todas-las-estaciones' : '/recetas/ensalada',
'/recetas' : '/recetas',
'/recetas/ensalada-de-arroz-y-aguacate' : '/recetas/r/ensalada-de-arroz-y-aguacate/esgp056',
'/recetas/ensalada-de-quinoa-con-aguacate' : '/recetas/ensalada',
'/blog/como-hacer-pasta-espelta-casera' : '/recetas/verduras/espelta',
'/blog/maiz-mazorca-perfecta-kikos-caseros' : '/recetas/verduras/maiz',
'/blog/recetas-con-remolacha-platos-faciles-cocina' : '/desde-1853/campo-hasta-plato/la-remolacha-un-bien-saludable/777/96',
'/recetas/crema-de-champinones-2' : '/recetas/r/crema-de-champinones/esgp055',
'/recetas/ensalada-de-maiz-dulce-a-la-italiana' : '/recetas/ensalada',
'/recetas/pastel-de-calabacin-con-gambas-y-salsa-de-piquillos' : '/recetas/verduras/calabacines',
'/blog/alimentos-con-calcio-de-origen-vegetal' : '/blog/tendencias',
'/productos/edamame-habas-de-soja' : '/productos/p/bonduelle-un-toque-de-edamame-habas-de-soja-lata-65-g.-pack-2/03083681079647',
'/recetas/ensalada-de-arroz-basmati' : '/recetas/r/ensalada-de-arroz-basmati/esgp049',
'/recetas/hamburguesas-vegetarianas-de-quinoa-y-remolacha' : '/recetas/r/hamburguesa-de-espelta-y-verduritas-fritas/esgp099',
'/blog/importancia-de-los-cereales-para-los-ninos' : '/recetas/r/bowl-estilo-mediterraneo/esgp081',
'/recetas/estofado-de-carne-de-toro-2' : '/recetas',
'/verduras/grelo' : '/desde-1853/campo-hasta-plato',
'/recetas/cupcakes-de-maiz' : '/recetas/verduras/maiz',
'/recetas/croquetas-de-espinacas-y-gambas' : '/recetas/r/croquetas-de-espinacas-y-gambas/esgp060',
'/recetas/quesadillas-de-verduras-y-jamon-serrano' : '/recetas',
'/blog/huevos-a-la-plancha-sanos-y-sabrosos' : '/recetas',
'/recetas/fetuccini-con-verduras' : '/recetas/r/ensalada-de-pasta-con-verduras-y-atun/esgp058',
'/recetas/cuscus-cremoso-al-curry-con-pollo-y-verduras' : '/recetas/r/cuscus-cremoso-al-curry-con-pollo-y-verduras/esgp033',
'/recetas/ensalada-de-legumbres' : '/recetas/ensalada',
'/recetas/tortilla-de-espinacas-con-jamon-y-queso' : '/recetas/verduras/espinacas',
'/recetas/receta-de-pastel-de-verduras-y-queso' : '/recetas',
'/recetas/noodles-con-brotes-de-soja-y-edamame' : '/recetas/verduras/edamame',
'/recetas/ternera-y-habas' : '/recetas/verduras/habas',
'/blog/3-platos-rapidos-y-faciles-para-el-dia-de-reyes' : '/recetas',
'/blog/recetas-con-guisantes-3-platos-sanos-y-ligeros' : '/recetas/verduras/guisantes',
'/blog/maiz-morado-maiz-azul-propiedades-receta' : '/recetas',
'/recetas/lasana-de-col' : '/recetas',
'/blog/edamame-recetas-con-un-toque-oriental' : '/recetas/verduras/edamame',
'/recetas/poke-bowl-de-salmon-y-edamame' : '/recetas/r/poke-bowl-de-salmon-y-edamame/esgp047',
'/recetas/croquetas-de-champinones-y-puerros' : '/recetas/r/croquetas-de-champinones-y-puerros/esgp062',
'/blog/aprovechar-una-coliflor-cocida' : '/blog/tendencias',
'/blog/tres-ideas-de-bocadillos-veganos' : '/blog/tendencias',
'/recetas/revuelto-de-calabacin-y-bacon-casero' : '/recetas/r/revuelto-de-calabacin-y-bacon-casero/esgp069',
'/recetas/pescado-al-curry-estilo-thai' : '/recetas/r/pescado-al-curry-estilo-thai/esgp043',
'/blog/platos-de-cuchara-preparate-para-el-invierno-con-recetas-calientes' : '/recetas/plato-principal',
'/productos/100-coliflor-en-forma-de-arroz' : '/productos/p/bonduelle-100-coliflor-en-forma-de-arroz-bolsa-400-g.-individual/03083681104325',
'/recetas/fideua-de-verduras-con-pavo' : '/recetas/r/fideua-de-verduras-con-pavo/esgp019',
'/recetas/puchero-andaluz' : '/recetas',
'/recetas/receta-de-bunuelos-de-zanahoria-y-parmesano' : '/recetas/verduras/zanahorias',
'/blog/menu-semanal-para-marzo-2016' : '/blog/tendencias',
'/blog/poke-bowls-3-recetas-de-moda-para-esta-primavera' : '/recetas',
'/blog/la-uva-mas-alla-del-vino-diferente-tipos-y-recetas' : '/blog/tendencias',
'/blog/queso-vegano-deliciosas-recetas' : '/recetas',
'/recetas/pastel-de-carne-picada-y-patata' : '/recetas/r/pastel-de-carne-picada-y-patata/esgp063',
'/recetas/quiche-de-maiz-y-queso-de-cabra' : '/recetas/verduras/maiz',
'/recetas/verduras-salteadas' : '/recetas',
'/recetas/ensalada-de-bonito-con-cebolla' : '/recetas/ensalada',
'/recetas/aguacates-al-horno-con-jamon' : '/recetas/verduras/aguacate',
'/blog/cuales-son-los-beneficios-de-las-ensalada-para-nuestro-organismo' : '/recetas/ensalada',
'/blog/las-cenas-en-familia-como-han-evolucionado-a-traves-de-los-anos' : '/blog/tendencias',
'/recetas/pure-de-zanahoria-con-muchas-vitaminas' : '/recetas/verduras/zanahorias',
'/recetas/receta-de-pastel-de-espinacas-con-jamon' : '/recetas/verduras/espinacas',
'/proceso-de-fabricacion' : '/desde-1853/campo-hasta-plato',
'/recetas/hojaldre-de-espinacas-con-gambas' : '/recetas/verduras/espinacas',
'/blog/aprovechar-el-aceite-de-una-conserva-de-atun' : '/blog/tendencias',
'/productos/brotes-germinados' : '/productos/p/bonduelle-brotes-germinados-lata-90-g.-pack-2/03083680994798',
'/recetas/albondigas-vegetarianas-con-maiz-y-guisantes' : '/recetas/verduras/maiz',
'/historia-bonduelle' : '/desde-1853/nuestra-historia',
'/recetas/pulpo-al-ajillo-con-champinones' : '/recetas/verduras/champinones',
'/blog/que-verduras-te-aportan-mas-energia' : '/blog/tendencias',
'/recetas/arroz-frito-con-col-rizada-y-calabaza' : '/recetas',
'/blog/5-recetas-faciles-y-rapidas-ideas-para-ser-el-chicote-de-tu-casa' : '/recetas',
'/recetas/apio-salteado-con-frutos-secos' : '/recetas/r/apio-salteado-con-frutos-secos/esgp001',
'/recetas/judias-con-tomate-y-patatas' : '/recetas/verduras/patatas',
'/recetas/arroz-guisado' : '/recetas',
'/recetas/wok-de-pollo-con-vegetales-salteados' : '/recetas',
'/blog/idea-para-cenar-brocoli-con-patatas-gratinado-al-horno' : '/recetas/verduras/patatas',
'/recetas/gnocchis-de-calabaza-al-pesto' : '/recetas',
'/blog/tarta-de-zanahoria-carrot-cake-recetas-tradicional-vegana' : '/recetas/verduras/zanahorias',
'/recetas/fideos-chinos-con-pollo-y-almendras' : '/recetas/r/fideos-chinos-con-pollo-y-almendras/esgp067',
'/blog/por-que-es-importante-el-agua-para-los-ninos' : '/blog/tendencias',
'/productos/congelados' : '/productos/tecnologia/congelado',
'/recetas/albondigas-a-la-madrilena-de-toda-la-vida' : '/recetas',
'/blog/recetas-faciles-y-baratas-cocina-por-menos-de-5' : '/blog/tendencias',
'/blog/algunos-errores-en-la-alimentacion' : '/blog/tendencias',
'/blog/cenas-ligeras-recetas-ligeras-para-despues-de-las-navidades' : '/blog/tendencias',
'/recetas/brownie-de-calabacin' : '/recetas/verduras/calabacines',
'/blog/recetas-con-quinoa-5-platos-que-tienes-que-cocinar' : '/recetas',
'/recetas/tarta-salada-de-verduras-y-ricotta' : '/recetas',
'/blog/tostas-vegetarianas-un-aperitivo-original' : '/recetas',
'/recetas/ensalada-de-remolacha' : '/recetas/ensalada',
'/blog/dieta-saludable-para-un-nino' : '/blog/tendencias',
'/blog/recetas-quinoa-para-adelgazar' : '/recetas',
'/recetas/acelgas-salteadas-con-langostinos' : '/recetas',
'/recetas/huevos-rellenos-de-champinones-bonduelle' : '/recetas/r/huevos-rellenos-de-champinones-bonduelle/esgp008',
'/blog/4-recetas-innovadoras-de-algunos-de-los-chefs-mas-famosos-del-mundo' : '/blog/tendencias',
'/blog/quinoa-donde-crece-planta-beneficiosa' : '/blog/tendencias',
'/productos/guisantes-al-natural-cocinados' : '/productos/p/bonduelle-guisantes-cocinados-extrafinos-frasco-465-g.-individual/08410375110372',
'/recetas/ensalada-de-edamame-con-tomates-cherry' : '/recetas/ensalada',
'/recetas/ensalada-de-quinoa-con-maiz' : '/recetas/ensalada',
'/blog/ideas-pizzas-masa-espelta' : '/recetas/verduras/espelta',
'/blog/recetas-para-ninos-sus-comidas-favoritas-para-cenar' : '/blog/tendencias',
'/productos/delicias-de-verduras-calabaza' : '/recetas',
'/blog/ensalada-del-mundo' : '/recetas/ensalada',
'/recetas/ensalada-de-corazones-de-alcachofa-con-apio' : '/recetas/ensalada',
'/recetas/lentejas-a-la-jardinera' : '/recetas',
'/productos/100-brocoli-en-forma-de-arroz' : '/productos/p/bonduelle-100-brocoli-en-forma-de-arroz-bolsa-400-g.-individual/03083681104288',
'/recetas/champinones-caramelizados-a-la-soja' : '/recetas/verduras/champinones',
'/recetas/ensalada-veraniega-multicolor' : '/recetas/ensalada',
'/productos/veggie-100-verduras-y-legumbres' : '/recetas',
'/recetas/nuevas-recetas' : '/recetas',
'/recetas/ensalada-de-palmitos-al-cabrales' : '/recetas/ensalada',
'/blog/que-ingredientes-podemos-anadir-las-ensalada-para-potenciar-su-sabor' : '/recetas/ensalada',
'/blog/como-hacer-verduras-al-vapor-con-sabor' : '/blog/tendencias',
'/recetas/ensalada-de-alubias' : '/recetas/ensalada',
'/recetas/espaguetis-negros-con-setas-y-salsa-de-nata' : '/recetas',
'/recetas/receta-de-salteado-de-esparragos-verdes' : '/recetas/verduras/esparragos',
'/productos/habas-finas' : '/productos/p/bonduelle-natur-habas-finas-lata-265-g.-individual/03083681003888',
'/recetas/ensalada-bonduelle-con-mermelada-de-tomate' : '/recetas/ensalada',
'/recetas/ensalada-con-crema-balsamica' : '/recetas/ensalada',
'/recetas/ensalada-de-garbanzos-salmon-y-bacalao-ahumados' : '/recetas/r/ensalada-de-garbanzos-salmon-y-bacalao-ahumados/esgp022',
'/productos/quinoa-blanca' : '/productos/p/bonduelle-un-toque-de-quinoa-blanca-lata-60-g.-pack-2/03083681085518',
'/recetas/merluza-en-caldo-corto-con-menestra-navarra' : '/recetas',
'/blog/recipientes-conservar-ensalada' : '/blog/tendencias',
'/productos/zanahoria-rallada' : '/productos/p/zanahoria-rallada-n-425-p1/03083681017687',
'/productos/apio-rallado' : '/productos/p/apio-rallado-240-p2/08410375112185',
'/productos/remolacha-en-dados' : '/productos/p/remolacha-en-dados-n-425-p1/03083681017656',
'/recetas/gofres-salados-de-espinacas-y-rucula' : '/recetas/verduras/espinacas',
'/recetas/ramen-picante-con-edamame-y-huevo' : '/recetas/verduras/edamame',
'/blog/champinones-al-ajillo-recetas-cocina-primer-plato-completo' : '/recetas/verduras/champinones',
'/recetas/coliflor-tres-delicias' : '/recetas/r/coliflor-tres-delicias/esgp092',
'/productos/guisantes-y-zanahorias' : '/productos/p/bonduelle-guisantes-y-zanahorias-muy-finos-lata-130-g.-pack-3/08410375110938',
'/blog/cantidad-verduras-ninos' : '/blog/tendencias',
'/blog/como-hacer-cebolla-caramelizada-paso-a-paso' : '/blog/tendencias',
'/blog/frutas-tropicales-propiedades-recetas-ensalada' : '/recetas/ensalada',
'/blog/habas-fritas-recetas-sabrosas-para-todos-los-gustos' : '/blog/tendencias',
'/blog/pasta-de-colores-como-elaborarla-paso-a-paso' : '/blog/tendencias',
'/productos/guisantes' : '/productos/verduras/guisantes',
'/productos/judias-verdes-finas-troceadas' : '/productos/p/bonduelle-judias-verdes-finas-troceadas-frasco-360-g.-individual/08410375110365',
'/productos/veggie-100-calabacin-y-guisantes-rigatoni' : '/productos/p/bonduelle-delicias-de-verdura-con-tomate-calabacin-y-berenjena-caja-300-g.-individual/03083680956529',
'/recetas/berenja-rellena-de-carne-y-verduritas' : '/recetas/verduras/berengenas',
'/recetas/filetes-de-pollo-a-la-plancha-con-salsa-de-champinones' : '/recetas/verduras/champinones',
'/recetas/albondigas-en-salsa-de-champinones' : '/recetas/verduras/champinones',
'/recetas/bocaditos-de-brocoli' : '/recetas/verduras/brocoli',
'/blog/preguntas-respuestas-sobre-cereal-espelta' : '/blog/tendencias',
'/contacto' : '/contacto',
'/recetas/ensalada-de-pasta-con-alubias-maiz-tomate-cebolla-y-pimiento' : '/recetas/ensalada',
'/recetas/ensalada-de-quinoa-con-aceitunas-negras' : '/recetas/ensalada',
'/recetas/sopa-de-verduras-con-maiz-bonduelle-para-la-termomix' : '/recetas/verduras/maiz',
'/recetas/tortilla-de-verduras-en-salsa' : '/recetas',
'/recetas/macarrones-con-cebollleta' : '/recetas',
'/recetas/salmon-confitado-con-pisto-de-verduras' : '/recetas',
'/esparrago' : '/productos/verduras/esparragos',
'/recetas/guacamole-con-salmon-ahumado' : '/recetas',
'/recetas/massaman-nua-ternera-en-salsa-cremosa-de-curry-rojo-y-leche-de-coco' : '/recetas/r/massaman-nua-ternera-en-salsa-cremosa-de-curry-rojo-y-leche-de-coco/esgp061',
'/recetas/pasta-de-colores-una-receta-facil-y-sana-para-ninos' : '/recetas',
'/recetas/pepitas-de-lentejas-y-zanahorias-bonduelle-veggie-con-pollo-a-la-parrilla-y-virutas-de-avellana' : '/recetas/verduras/zanahorias',
'/recetas/tartar-de-atun-rojo-con-queso-de-cabra-aguacate-y-frutos-rojos' : '/recetas/verduras/aguacate',
'/blog/5-entrantes-verduras-cenas-navidad' : '/blog/tendencias',
'/blog/sal-de-aceitunas-negras-como-se-prepara' : '/blog/tendencias',
'/recetas/ensalada-de-arroz-con-gambas-y-setas' : '/recetas/ensalada',
'/blog/verduras-condimentos-sabor' : '/blog/tendencias',
'/blog/escaldar-tomates-paso-a-paso' : '/blog/articulo/escaldar-tomates-para-pelarlos/1017/1017',
'/recetas/flan-de-zanahorias' : '/recetas/verduras/zanahorias',
'/blog/5-recetas-gourmet-para-cenar' : '/blog/tendencias',
'/blog/tempura-de-verduras-la-receta-perfecta' : '/recetas',
'/recetas/salmon-con-rodajas-de-calabacin' : '/recetas/verduras/calabacines',
'/blog/5-pasos-para-organizar-la-cocina' : '/blog/tendencias',
'/blog/5-platos-verduras-divertidos' : '/blog/tendencias',
'/blog/ensalada-originales-5-variantes-increibles-de-un-clasico' : '/recetas/ensalada',
'/blog/sopas-calientes-5-recetas-de-sopas-esenciales-para-combatir-el-frio' : '/recetas/sopa-crema',
'/recetas/albondigas-de-bacalao-fresco-con-salsa-de-piquillos' : '/recetas',
'/recetas/ensalada-de-judias-con-zanahoria-y-champinones' : '/recetas/ensalada',
'/blog/prepara-deliciosos-sandwiches-vegetales' : '/blog/tendencias',
'/recetas/ensalada-payaso' : '/recetas/ensalada',
'/recetas/pimientos-rellenos-de-maiz' : '/recetas/verduras/maiz',
'/recetas/receta-de-berenjenas-rellenas-de-atun-y-gambas' : '/recetas/verduras/berengenas',
'/productos/espelta' : '/productos/verduras/espelta',
'/blog/frutas-y-verduras-cuando-se-pueden-utilizar-juntas' : '/blog/tendencias',
'/blog/recetas-con-champinones-el-producto-estrella-del-otono' : '/recetas/verduras/champinones',
'/recetas/ensalada-de-corazones-de-alcachofa-con-esparragos' : '/recetas/ensalada',
'/recetas/sopa-de-verduras' : '/recetas/r/sopa-de-verduras-con-puerro/esgp068',
'/recetas/tortilla-de-guisantes-con-jamon' : '/recetas/verduras/guisantes',
'/recetas/verduras' : 'No existe una página general',
'/blog/guacamole-como-preparar-la-mejor-receta' : '/recetas',
'/blog/idea-para-cenar-tosta-de-aguacate-con-huevos-revueltos' : '/recetas/verduras/aguacate',
'/grupo-bonduelle' : '/desde-1853/articulo/la-nueva-firma-del-grupo-bonduelle-la-nature-notre-futur/1248/128',
'/recetas/tarta-de-bacon-champinones-y-puerro' : '/recetas/verduras/champinones',
'/blog/ensalada-templadas-5-recetas-de-ensalada-para-el-invierno' : '/recetas/ensalada',
'/blog/relacion-entre-rendimiento-escolar-y-alimentacion' : '/blog/tendencias',
'/recetas/ensalada-de-aguacate-con-quinoa-y-edamame' : '/recetas/verduras/aguacate',
'/recetas/ensaladilla-de-bacalao' : '/recetas',
'/recetas/macarrones-con-brocoli-y-guisantes-bonduelle' : '/recetas/verduras/guisantes',
'/recetas/brochetas-de-pollo-y-verduras' : '/recetas',
'/recetas/ensalada-de-arroz' : '/recetas/r/ensalada-de-arroz-con-verduras/esgp023',
'/recetas/huevos-rellenos-de-maiz-y-salsa-rosa' : '/recetas/verduras/maiz',
'/blog/que-cenar-hoy-aprende-a-improvisar' : '/blog/tendencias',
'/recetas/arroz-meloso-con-atun' : '/recetas',
'/recetas/huevos-mollet-con-coles-de-bruselas' : '/recetas/verduras/col',
'/blog/el-alino-de-las-ensalada-antes-o-despues-de-servirlas' : '/recetas/ensalada',
'/blog/menu-saludablejulio' : '/blog/tendencias',
'/productos/conservas' : '/preguntas-frecuentes/conserva/contenido-conservantes-conservas/97',
'/recetas/amante-vegetales' : '/recetas',
'/recetas/crema-de-judias-verdes' : '/recetas/verduras/judias-verdes',
'/recetas/ensalada-crudites' : '/recetas/ensalada',
'/recetas/guisantes-con-pure-de-patatas-y-jamon-para-disfrutar' : '/recetas/verduras/patatas',
'/recetas/morcillo-guisado-con-espaguetis' : '/recetas',
'/recetas/tabule-de-brocoli-con-pollo-al-curry' : '/recetas/r/tabule-de-brocoli-con-pollo-al-curry/esgp089',
'/recetas/verduritas-al-vapor' : '/recetas',
'/blog/recetas-con-apio-platos-saludables' : '/blog/tendencias',
'/recetas/merluza-rellena-de-gambas-y-verduras' : '/recetas',
'/blog/cenas-en-familia-recetas-faciles-para-cenar' : '/blog/tendencias',
'/blog/ensalada-de-tomate-con-mozzarella-y-oregano' : '/recetas/ensalada',
'/blog/las-propiedades-de-los-guisantes-y-como-prepararlos' : '/blog/tendencias',
'/recetas/coliflor-asada-al-curry' : '/recetas/verduras/coliflor',
'/recetas/ensalada-de-lentejas-y-soja' : '/recetas/ensalada',
'/recetas/ensalada-italiana-de-arroz-de-coliflor' : '/recetas/r/ensalada-italiana-de-arroz-de-coliflor/esgp091',
'/recetas/hamburguesa-vegetariana' : '/recetas',
'/recetas/maiz-con-macarrones-con-tomate' : '/recetas/verduras/maiz',
'/recetas/pepitas-de-guisantes-y-calabacin-bonduelle-veggie-con-verduras-y-lascas-de-parmesano' : '/recetas/verduras/calabacines',
'/recetas/receta-de-pure-de-zanahorias' : '/recetas/verduras/zanahorias',
'/recetas/wafles-salados-con-mozarella-tomate' : '/recetas',
'/blog/champinones-rellenos-de-verduras-sorprende-a-tus-amigos' : '/recetas/verduras/champinones',
'/blog/idea-jardinera-de-verduras' : '/blog/tendencias',
'/recetas/enchilada-mexicana-vegetal' : '/recetas',
'/recetas/hamburguesa-de-quinua-con-queso-parmesano-y-albahaca' : '/recetas',
'/recetas/salpicon-de-marisco' : '/recetas',
'/recetas/tortilla-vegetal' : '/recetas',
'/blog/como-conservar-las-verduras-y-hortalizas-en-invierno' : '/blog/tendencias',
'/blog/gazpacho-o-salmorejo-diferencias-entre-las-dos-recetas-que-deberias-saber' : '/recetas/sopa-crema',
'/recetas/gratinado-de-pan-con-repollo-romanesco-y-zanahoria' : '/recetas/r/gratinado-de-pan-con-repollo-romanesco-y-zanahoria/esgp095',
'/recetas/milhojas-de-patata-gratinadas-con-setas-y-jamon-serrano' : '/recetas/verduras/patatas',
'/recetas/revuelto-de-champinones-con-jamon-un-plato-completo' : '/recetas/verduras/champinones',
'/blog/alimentacion-variada-en-los-ninos-y-jovenes' : '/blog/tendencias',
'/blog/cenas-para-ninos-trucos-para-que-tus-cenas-sean-mas-divertidas' : '/blog/tendencias',
'/recetas/alcachofas-rellenas-de-carne' : '/recetas/verduras/alcachofas',
'/recetas/gazpacho-andaluz' : '/recetas/r/gazpacho-andaluz/esgp017',
'/recetas/magdalenas-de-zanahoria-rellenas-de-crema-y-queso' : '/recetas/verduras/zanahorias',
'/recetas/pure-de-pescado-con-zanahoria-rallada-2' : '/recetas',
'/recetas/tortilla-de-alcachofas' : '/recetas/verduras/alcachofas',
'/blog/diferentes-maneras-de-hacer-tortilla-de-patata' : '/recetas/verduras/patatas',
'/blog/un-par-de-recetas-de-garbanzos-con-quinoa' : '/recetas',
'/productos/salteado-estilo-mediterraneo' : '/productos/p/bonduelle-salteado-estilo-mediterraneo-bolsa-400-g.-individual/03083681106572',
'/recetas/calabaza-asada-con-brocoli-y-almendras' : '/recetas/verduras/brocoli',
'/recetas/ensalada-de-patata-con-bonito' : '/recetas/ensalada',
'/recetas/tabule-con-salmon-y-verduras-bonduelle' : '/recetas',
'/verduras' : 'No existe una página general',
'/blog/bizcocho-tortitas-harina-de-espelta' : '/recetas/verduras/espelta',
'/blog/la-mejor-ensalada-alimentos-basicos-ensalada-completa' : '/recetas/ensalada',
'/blog/otra-forma-de-comer-berenjenas-de-almagro' : '/blog/tendencias',
'/recetas/bacalao-con-espinacas' : '/recetas/r/bacalao-con-espinacas/esgp102',
'/recetas/sopa-de-maiz-y-rabanos' : '/recetas/verduras/maiz',
'/blog/ideas-postre-veganos' : '/blog/tendencias',
'/recetas/ensalada-de-alubias-con-verduras-crujientes' : '/recetas/ensalada',
'/recetas/ensalada-de-endibias-y-pollo' : '/recetas/ensalada',
'/recetas/verduras-estofadas-a-las-3-carnes' : '/recetas',
'/blog/aperitivos-faciles-para-preparar-esta-navidad' : '/recetas/aperitivo-tapa',
'/blog/ensalada-de-verano-5-recetas-para-combatir-el-calor' : '/recetas/ensalada',
'/blog/las-mejores-recetas-de-verduras-para-los-ninos-primeros-platos' : '/blog/tendencias',
'/blog/menu-saludable-septiembre' : '/blog/tendencias',
'/blog/preparar-verduras-mas-sabrosas' : '/blog/tendencias',
'/blog/sopa-letras-verduras' : '/blog/tendencias',
'/productos/champinones-mini' : '/productos/p/champinones-laminados-al-natural/03333160018316',
'/recetas/guisantes-con-arroz-salteados-con-taquitos-de-jamon' : '/recetas/verduras/guisantes',
'/blog/como-cortar-verduras-para-tus-ensalada' : '/recetas/ensalada',
'/blog/consejos-para-conservar-los-alimentos-en-verano' : '/blog/tendencias',
'/blog/el-maiz-todo-lo-que-tienes-que-saber-sobre-este-alimento' : '/blog/tendencias',
'/recetas/ensalada-tibia-de-lentejas' : '/recetas/ensalada',
'/recetas/receta-de-guisantes-con-queso' : '/recetas/verduras/guisantes',
'/recetas/tallarines-de-calabacin-con-bolonesa-de-lentejas' : '/recetas/verduras/calabacines',
'/blog/alimentacion-sana-y-deporte-para-ninos' : '/blog/tendencias',
'/blog/decora-tus-ensalada-con-las-mejores-verduras' : '/recetas/ensalada',
'/blog/las-mejores-verduras-para-la-vista' : '/blog/tendencias',
'/blog/las-propiedades-del-pepino-y-como-prepararlo' : '/desde-1853/campo-hasta-plato/pepino/1369/1369',
'/recetas/ensalada-de-cuscus' : '/recetas/ensalada',
'/recetas/guisantes-con-puerros-tiernos-jamon-serrano-y-estragon' : '/recetas/verduras/guisantes',
'/recetas/judias-verdes-con-tomate-y-jamon' : '/recetas/verduras/judias-verdes',
'/recetas/opastel-de-berenjena-con-salsa-de-cebolla' : '/recetas/verduras/berengenas',
'/recetas/salteado-de-guisantes-y-repollo-con-panceta' : '/recetas/verduras/guisantes',
'/blog/los-superalimentos-los-heroes-de-la-alimentacion' : '/blog/tendencias',
'/blog/magdalenas-espelta-dos-deliciosas-recetas' : '/recetas/verduras/espelta',
'/blog/que-son-los-zoodles' : '/blog/tendencias',
'/productos/ensalada-mediterranea' : '/productos/p/bonduelle-ensalada-mediterranea-frasco-310-g.-individual/08410375110693',
'/productos/remolacha-en-rodajas' : '/productos/p/bonduelle-remolacha-en-rodajas-frasco-305-g.-individual/08410375110280',
'/productos/veggie-100-lentejas-y-zanahoria-penne' : '/productos/p/zanahoria-rallada/08410375110297',
'/recetas/crema-de-verduras' : '/recetas',
'/recetas/pimientos-rojos-con-champinones' : '/recetas',
'/recetas/receta-de-aguacate-relleno-de-verduras-y-pollo' : '/recetas/verduras/aguacate',
'/blog/conoce-algunas-de-las-recetas-mas-sabrosas-de-sudamerica' : '/blog/tendencias',
'/blog/equilibra-tu-alimentacion-y-cuidate-con-el-pilates' : '/blog/tendencias',
'/blog/menu-mensual-para-marzo-2018' : '/blog/tendencias',
'/productos/veggie-pepitas-100-guisante-y-calabacin' : '/productos',
'/recetas/menestra-de-verduras-con-gambas' : '/recetas',
'/recetas/receta-de-sandwich-de-remolacha-y-lechuga' : '/recetas',
'/blog/curcuma-beneficios-propiedades-especia-india' : '/blog/tendencias',
'/blog/moler-la-pimienta-al-momento' : '/blog/tendencias',
'/productos/salteado-estilo-parisino' : '/productos/p/bonduelle-salteado-estilo-parisino-bolsa-400-g.-individual/03083681106480',
'/productos/veggie' : '/productos',
'/recetas/atunada-con-guisantes-y-tomate' : '/recetas/verduras/guisantes',
'/recetas/ensalada-de-arroz-y-pollo' : '/recetas/ensalada',
'/blog/menu-semanal-para-junio-2016' : '/blog/tendencias',
'/productos/maiz-bio' : '/productos/p/maiz-bio-sin-azucares-anadidos/03083681010152',
'/productos/pimientos-del-piquillo-en-tiras' : '/productos/p/bonduelle-pimientos-del-piquillo-en-tiras-frasco-220-g.-individual/08410624109065',
'/recetas/albondigas-con-arroz-y-zanahoria-rallada-2' : '/recetas/verduras/zanahorias',
'/recetas/burger-vegetal-en-pan-pretzel' : '/recetas/r/burger-vegetal-en-pan-pretzel/esgp082',
'/recetas/hamburguesa-de-pollo-con-champinones-a-la-plancha' : '/recetas/verduras/champinones',
'/verduras/achicoria' : '/desde-1853/campo-hasta-plato',
'/blog/beneficios-de-bonduelle-en-tus-ensalada' : '/recetas/ensalada',
'/blog/que-alimentos-comer-si-practicas-habitualmente-running' : '/blog/tendencias',
'/productos/champinones-al-natural' : '/productos/p/bonduelle-champinones-laminados-al-natural-lata-170-g.-individual/03083681047806',
'/productos/champinones-laminados' : '/productos/p/bonduelle-champinones-laminados-al-natural-lata-170-g.-individual/03083681047806',
'/productos/delicias-de-verduras-tomate' : '/productos/p/delicias-de-verdura-con-tomate/03083680956529',
'/productos/maiz-dulce-en-grano-al-vacio' : '/productos/verduras/maiz',
'/productos/veggie-pepitas-100-lentejas-y-zanahoria' : '/productos',
'/recetas/berenjenas-rellenas-con-champinones' : '/recetas/r/berenjenas-rellenas-con-champinones/esgp032',
'/recetas/curry-de-gambas-y-guisantes' : '/recetas/verduras/guisantes',
'/recetas/emperador-con-mayonesa-de-maiz' : '/recetas/verduras/maiz',
'/recetas/ensalada-con-brocoli-y-anchoas' : '/recetas/ensalada',
'/recetas/ensalada-de-remolacha-con-endibias' : '/recetas/ensalada',
'/recetas/tortellini-con-salsa-de-guisantes-y-cheddar' : '/recetas/verduras/guisantes',
'/blog/3-recetas-menu-vegetariano-facil' : '/blog/tendencias',
'/blog/cenas-ligeras-recetas-digestivas-para-cenar-en-verano' : '/blog/tendencias',
'/blog/el-desconocido-mundo-de-la-gastrobotanica' : '/blog/tendencias',
'/blog/introduccion-de-alimentos-al-bebe-cuando-empiezan-a-comer-los-bebes' : '/blog/tendencias',
'/blog/menu-mensual-para-febrero-2018' : '/blog/tendencias',
'/blog/paella-origen-recetas-cocina-populares' : '/blog/tendencias',
'/blog/reutilizar-una-ensaladilla-rusa' : '/blog/tendencias',
'/blog/slow-food-el-estilo-de-vida-saludable-que-esta-de-moda' : '/blog/tendencias',
'/blog/variedad-de-recetas-con-maiz' : '/blog/tendencias',
'/recetas/bisque-de-mariscos' : '/recetas',
'/recetas/coctel-de-langostinos-con-maiz-bonduelle' : '/recetas/verduras/maiz',
'/recetas/ensalada-de-pasta-con-atun' : '/recetas/ensalada',
'/recetas/receta-de-pimientos-con-nata' : '/recetas/verduras/pimientos',
'/blog/cocina-ninos' : '/blog/tendencias',
'/blog/recetas-con-calabacin-4-recetas-que-no-te-dejaran-indiferente' : '/blog/tendencias',
'/recetas/ensalada-de-aguacate-y-apio' : '/recetas/ensalada',
'/recetas/ensalada-de-endivias-con-datiles-viaja-a-oriente' : '/recetas/ensalada',
'/recetas/ensalada-de-judias-verdes-y-pimientos-con-un-toque-de-maiz' : '/recetas/ensalada',
'/recetas/filetes-de-seitan-rellenos-de-calabacin-y-queso-con-salsa-de-champinones' : '/recetas/verduras/calabacines',
'/recetas/pisto-de-berenjena-2' : '/recetas/verduras/berengenas',
'/verduras/calabacin' : '/desde-1853/campo-hasta-plato/el-calabacin-una-verdura-muy-versatil/786/101',
'/blog' : '/blog/novedades',
'/blog/10-alinos-deliciosos-para-tus-ensalada-de-verano' : '/recetas/ensalada',
'/blog/la-vinagreta-el-aderezo-perfecto-para-tus-ensalada' : '/recetas/ensalada',
'/blog/moler-el-azafran' : '/blog/tendencias',
'/blog/salteado-de-alcachofas-y-garbanzos' : '/blog/tendencias',
'/recetas/ensalada-cesar' : '/recetas/ensalada',
'/recetas/fanatico-dieta' : '/recetas',
'/recetas/receta-de-menestra-de-verduras' : '/recetas',
'/blog/5-trucos-para-ser-un-instagramer-de-la-cocina' : '/blog/tendencias',
'/blog/idea-para-cenar-garbanzos-salteados-con-verduras-y-pollo' : '/blog/tendencias',
'/blog/te-tipos-propiedades-para-salud' : '/blog/tendencias',
'/recetas/coctel-de-maiz' : '/recetas/verduras/maiz',
'/recetas/ensalada-de-garbanzos-y-queso-feta' : '/recetas/ensalada',
'/recetas/ensalada-de-merluza' : '/recetas/ensalada',
'/recetas/revuelto-de-matanza-y-palmitos' : '/recetas',
'/recetas/sopa-minestrone' : '/recetas/sopa-crema',
'/blog/idea-para-cenar-aguacate-relleno-de-tomates-y-gambas' : '/recetas/verduras/aguacate',
'/blog/menu-mensual-para-enero-2018' : '/blog/tendencias',
'/blog/nombres-ocultos-verduras' : '/blog/tendencias',
'/blog/receta-de-champinones-en-salsa-platos' : '/blog/tendencias',
'/recetas/ensalada-de-champinones-y-calabacin' : '/recetas/ensalada',
'/recetas/ensalada-de-invierno' : '/recetas/ensalada',
'/recetas/entrecot-con-habas-y-patatas' : '/recetas/verduras/patatas',
'/recetas/huevos-con-salmon-a-la-flamenca' : '/recetas',
'/recetas/menestra-de-conejo' : '/recetas',
'/recetas/merluza-con-crema-de-maiz' : '/recetas/verduras/maiz',
'/recetas/pulpo-a-la-gallega-siglo-xxi' : '/recetas',
'/recetas/pure-de-remolacha-y-semola' : '/recetas/verduras/remolacha',
'/recetas/receta-de-patatas-asadas-con-espinacas' : '/recetas/verduras/patatas',
'/recetas/receta-de-sopa-de-minestrone' : '/recetas/sopa-crema',
'/recetas/tortilla-de-guisantes-y-canonigos' : '/recetas/verduras/guisantes',
'/recetas/verduras-enharinadas-con-arroz' : '/recetas',
'/blog/10-alimentos-para-fortalecer-el-pelo' : '/blog/tendencias',
'/blog/4-hortalizas-para-esta-primavera' : '/blog/tendencias',
'/blog/cenas-ligeras-5-ideas-para-no-pasarte-cenando' : '/blog/tendencias',
'/blog/ensalada-ligeras-5-recetas-para-refrescarte' : '/recetas/ensalada',
'/blog/los-muppies-deporte-vida-sana-y-redes-sociales' : '/blog/tendencias',
'/blog/quitar-las-pepitas-al-pepino' : '/blog/tendencias',
'/blog/recetas-originales-para-hacer-con-ninos' : '/blog/tendencias',
'/recetas/bunuelos-de-coliflor' : '/recetas/verduras/coliflor',
'/recetas/ensalada-de-judias-verdes' : '/recetas/r/ensalada-de-judias-verdes-y-patatas-con-pesto/esgp075',
'/recetas/ensalada-de-judias-verdes-y-langostinos' : '/recetas/verduras/judias-verdes',
'/recetas/judias-verdes-con-tomate' : '/recetas/verduras/judias-verdes',
'/recetas/nasi-de-brocoli-en-forma-de-arroz-con-carne-picada-y-champinones' : '/recetas/r/nasi-de-brocoli-en-forma-de-arroz-con-carne-picada-y-champinones./esgp090',
'/recetas/poke-bowl-con-atun-crudo-y-edamame' : '/recetas/r/poke-bowl-de-salmon-y-edamame/esgp047',
'/recetas/tortilla-de-zanahoria-y-brocoli-bonduelle' : '/recetas/verduras/zanahorias',
'/blog/como-conservar-las-ensalada-de-verano' : '/recetas/ensalada',
'/blog/descubre-algunos-platos-de-africa' : '/blog/tendencias',
'/blog/menu-semanal-para-octubre-2016' : '/blog/tendencias',
'/blog/pan-de-espelta-que-es-como-prepararlo' : '/blog/tendencias',
'/blog/recetas-de-legumbres-platos-para-hacer-en-verano' : '/blog/tendencias',
'/blog/salteado-de-alubias-blancas-con-maiz-y-guisantes' : '/recetas/verduras/guisantes',
'/productos/burger-vegetal-2' : '/productos',
'/productos/veggie-100-garbanzo-y-maiz-fusilli' : '/productos',
'/recetas/bizcocho-zanahoria-sopa-caliente-turron' : '/recetas/verduras/zanahorias',
'/recetas/ensalada-de-espinacas-con-arandanos-edamame-y-quinoa' : '/recetas/verduras/edamame/recetas/verduras/espinacas',
'/recetas/receta-de-foie-gras-de-pato-sobre-quenelle-de-champinones-y-reduccion-de-vino-tinto' : '/recetas/verduras/champinones',
'/recetas/sopas-y-cremas' : '/recetas/sopa-crema',
'/blog/5-ideas-rapidas-y-faciles-para-cenar-en-casa' : '/blog/tendencias',
'/blog/atemperar-quesos-para-su-degustacion' : '/blog/tendencias',
'/blog/bonduelle-te-ensena-a-preparar-tus-verduras-al-estilo-oriental' : '/blog/tendencias',
'/blog/comida-sana-para-llevar-al-trabajo' : '/blog/tendencias',
'/blog/como-empezar-una-vida-sana' : '/blog/tendencias',
'/blog/conservacion-ensalada-maxima-frescura' : '/recetas/ensalada',
'/blog/idea-estofado-de-garbanzos-con-aceitunas-negras' : '/recetas/verduras/aceitunas-negras',
'/blog/recetas-vegetarianas-sabor-y-sencillez' : '/blog/tendencias',
'/blog/videos-de-cocina-las-mejores-video-recetas-de-verduras' : '/blog/tendencias',
'/productos/cereales-y-semillas' : '/productos/p/bonduelle-un-toque-de-cereales-y-semillas-lata-85-g.-pack-2/03083681097009',
'/productos/guisantes-sin-azucar' : '/productos/p/bonduelle-bio-guisantes-sin-azucares-anadidos-procedentes-agricultura-ecologica-lata-130-g.-pack-2/03083681079708',
'/recetas/albondigas-de-quinoa-con-ensalada' : '/recetas/ensalada',
'/recetas/alcachofas-rellenas-de-foie-y-habitas' : '/recetas/verduras/alcachofas',
'/recetas/bolsitas-de-pasta-filo-con-crema-de-maiz-y-beicon' : '/recetas/verduras/maiz',
'/recetas/ensalada-campera-con-tomate' : '/recetas/ensalada',
'/recetas/ensalada-de-judias-verdes-con-tofu' : '/recetas/verduras/judias-verdes',
'/recetas/ensalada-rustica-de-maiz-a-la-miel-con-vinagre-balsamico' : '/recetas/ensalada',
'/recetas/patatas-en-nido-con-verduras' : '/recetas/verduras/patatas',
'/recetas/pavo-guisado' : '/recetas',
'/recetas/pure-de-verduras' : '/recetas/sopa-crema',
'/blog/5-ideas-de-cenas-rapidas-para-no-perder-el-tiempo' : '/blog/tendencias',
'/blog/los-jovenes-y-el-deporte' : '/blog/tendencias',
'/blog/que-picar-entre-horas-sano-y-delicioso' : '/blog/tendencias',
'/blog/recuerda-por-que-hay-que-comer-verduras' : '/blog/tendencias',
'/blog/trucos-de-cocina-haz-tus-cenas-mas-faciles-y-rapidas' : '/blog/tendencias',
'/recetas/crepes-de-verduras-a-la-coreana' : '/recetas',
'/recetas/pollo-al-limon-con-fideos-chinos-y-verduras' : '/recetas',
'/recetas/tostada-de-aguacate-huevo-y-edamame' : '/recetas/verduras/aguacate',
'/setas' : '/desde-1853/campo-hasta-plato',
'/blog/10-segundos-platos-para-navidad' : '/blog/tendencias',
'/blog/el-hinojo-descubre-los-beneficios-para-tu-organismo' : '/blog/tendencias',
'/blog/pizzas-recetas-de-pizzas-saludables-para-todos-los-gustos' : '/blog/tendencias',
'/blog/propuesta-de-menu-saludable-para-marzo' : '/blog/tendencias',
'/blog/recetas-al-horno-6-recetas-para-sacarle-partido-a-tu-horno' : '/blog/tendencias',
'/recetas/arroz-con-champinones' : '/recetas/verduras/champinones',
'/recetas/crema-de-calabacin-2' : '/recetas/verduras/calabacines',
'/recetas/delicia-de-rigatoni-de-guisantes-y-calabacin-bonduelle-veggie-a-la-italiana' : '/recetas/verduras/calabacines',
'/recetas/ensalada-de-arroz-salvaje-con-frijoles' : '/recetas/ensalada',
'/recetas/ensalada-de-champinones' : '/recetas/ensalada',
'/recetas/ensalada-de-champinones-y-espinacas' : '/recetas/verduras/espinacas',
'/recetas/ensalada-de-judias-zanahorias-y-jamon' : '/recetas/ensalada',
'/recetas/ensalada-tres-delicias' : '/recetas/ensalada',
'/recetas/hamburguesa-de-bacalao-con-hierbas-y-guisantes' : '/recetas/verduras/guisantes',
'/recetas/pulpo-a-la-gallega' : '/recetas',
'/recetas/receta-de-ensalada-de-patata' : '/recetas/ensalada',
'/recetas/rollitos-de-maiz-dulce-y-aguacate' : '/recetas/verduras/aguacate',
'/recetas/tarta-con-espinacas-y-queso' : '/recetas/verduras/espinacas',
'/recetas/tostadas-de-aguacate' : '/recetas/verduras/aguacate',
'/blog/cena-con-amigos-mini-wraps-de-verduras-y-jamon-york' : '/blog/tendencias',
'/blog/como-hacer-tempura-de-verduras' : '/blog/articulo/como-hacer-tempura-de-verduras/1021/1021',
'/blog/dos-recetas-de-chorizo-vegano' : '/blog/tendencias',
'/blog/menu-febrero' : '/blog/tendencias',
'/blog/propuesta-de-menu-saludable-para-abril' : '/blog/tendencias',
'/blog/propuesta-de-menu-saludable-para-febrero' : '/blog/tendencias',
'/blog/recetas-bajas-en-calorias-3-trucos-sencillos' : '/blog/tendencias',
'/blog/recetas-thermomix-para-ninos-postre-sanas-sin-gluten' : '/blog/tendencias',
'/blog/rehidratacion-de-un-pimiento-seco' : '/blog/tendencias',
'/blog/remojo-del-garbanzo' : '/blog/tendencias',
'/blog/truco-abrir-los-lichis' : '/blog/tendencias',
'/recetas/bizcocho-de-zanahoria-y-manzana' : '/recetas/verduras/zanahorias',
'/recetas/bowl-estilo-mediterraneo' : '/recetas/r/bowl-estilo-mediterraneo/esgp081',
'/recetas/ensalada-de-quinua-con-maiz-asado-y-aguacate' : '/recetas/ensalada',
'/recetas/ensaladita-de-soja-y-altramuces-2' : '/recetas/ensalada',
'/recetas/trigo-salteado-con-maiz-guisante-y-agridulce-de-remolacha-2' : '/recetas/verduras/maiz',
'/blog/5-alimentos-que-ayudan-a-desintoxicar-el-organismo' : '/blog/tendencias',
'/blog/5-segundos-platos-cena-navidad' : '/blog/tendencias',
'/blog/cena-sano-las-mejores-recetas-de-comida-sana-para-cenar' : '/blog/tendencias',
'/blog/escurrir-todo-tipo-de-verduras-de-hoja' : '/blog/tendencias',
'/blog/idea-filetear-mango-para-hacer-a-la-plancha' : '/blog/tendencias',
'/blog/idea-para-cenar-tortilla-de-verduras' : '/blog/tendencias',
'/blog/idea-usar-pitahaya-amarilla-en-las-ensalada' : '/recetas/ensalada',
'/blog/menu-sano-equilibrado-octubre' : '/blog/tendencias',
'/blog/menu-semanal-para-septiembre-2016' : '/blog/tendencias',
'/blog/propuesta-de-menu-sano-para-junio' : '/blog/tendencias',
'/blog/tabla-de-alimentacion-para-los-ninos' : '/blog/tendencias',
'/blog/tentempies-para-deportistas' : '/blog/tendencias',
'/blog/trucos-para-preparar-comidas-sanas-y-rapidas' : '/blog/tendencias',
'/blog/trucos-para-preparar-sopas-deliciosas' : '/blog/tendencias',
'/blog/utilizar-la-pulpa-del-ajo-asado' : '/blog/tendencias',
'/blog/variedad-de-recetas-con-guisantes' : '/blog/tendencias',
'/productos/gama-un-toque-de' : 'No existe una página general',
'/productos/guisantes-bio' : '/productos/p/guisantes-bio/03083681106428',
'/productos/maiz' : '/productos/verduras/maiz',
'/recetas/bacalao-confitado-con-crema-de-guisantes-bonduelle' : '/recetas/verduras/guisantes',
'/recetas/crudites-con-hummus-tradicional' : '/recetas',
'/recetas/ensaladilla-rusa-2' : '/recetas',
'/recetas/paquetitos-de-ternera-con-alcachofas' : '/recetas/verduras/alcachofas',
'/recetas/pizza-pirata-vegetariana' : '/recetas',
'/blog/5-ideas-para-que-los-ninos-coman-verduras' : '/blog/tendencias',
'/blog/ideas-menu-semanal-vegetariano' : '/blog/tendencias',
'/blog/la-dieta-globalizada' : '/blog/tendencias',
'/blog/menu-mensual-para-marzo-2017' : '/blog/tendencias',
'/blog/sopa-de-letras' : '/blog/tendencias',
'/productos/judias-verdes' : '/productos/verduras/judias-verdes',
'/productos/judias-verdes-extra-finas' : '/productos/verduras/judias-verdes',
'/recetas/albondigas-de-pavo-en-salsa-con-guisantes-y-ajetes' : '/recetas/verduras/guisantes',
'/recetas/bacalao-con-verduras-y-calabacin' : '/recetas/verduras/calabacines',
'/recetas/bol-de-kale-con-quinoa-y-edamame' : '/recetas/verduras/edamame',
'/recetas/cremoso-de-guisantes-con-crujiente-de-calabaza' : '/recetas/verduras/guisantes',
'/recetas/endivias-rellenas' : '/recetas/ensalada',
'/recetas/ensalada-de-cogollos-rellenos-con-tomate-confitado' : '/recetas/ensalada',
'/recetas/ensalada-de-jamon-dulce-con-remolacha' : '/recetas/ensalada',
'/recetas/ensalada-de-quinoa-con-brocoli-y-granada' : '/recetas/ensalada',
'/recetas/ensalada-de-remolacha-y-huevo-2' : '/recetas/ensalada',
'/recetas/ensalada-de-soja-y-judias-verdes-2' : '/recetas/ensalada',
'/recetas/ensalada-mexicana-crujiente' : '/recetas/ensalada',
'/recetas/habas-con-cebolleta-y-brotes-de-soja' : '/recetas/verduras/habas',
'/recetas/pimientos-rellenos-de-quinoa-vegetales-y-queso' : '/recetas/verduras/pimientos',
'/recetas/plato-principal' : '/recetas/plato-principal',
'/recetas/ragu-rapido-de-ternera-y-habas-2' : '/recetas/verduras/habas',
'/blog/5-consejos-para-comer-mas-sano' : '/blog/tendencias',
'/blog/cena-navidad-verduras' : '/blog/tendencias',
'/blog/dos-recetas-dulces-con-harina-de-espelta' : '/recetas/verduras/espelta',
'/blog/ideas-saludables-desayunos-veganos' : '/blog/tendencias',
'/blog/kebap-durum-recetas-faciles' : '/blog/tendencias',
'/blog/recetas-con-calabaza-3-platos-para-chuparse-los-dedos' : '/recetas/verduras/calabaza',
'/productos/basicos' : '/productos',
'/productos/judias-verdes-finas-troceadas-gama-naturplus' : '/recetas/verduras/judias-verdes',
'/recetas/conejo-aromatizado-con-champinones' : '/recetas/verduras/champinones',
'/recetas/ensalada-de-alcachofas-con-pimientos-rojos' : '/recetas/ensalada',
'/recetas/ensalada-de-boquerones-con-verduritas-2' : '/recetas/ensalada',
'/recetas/ensalada-de-crudites-bonduelle-con-salsa-de-roquefort' : '/recetas/ensalada',
'/recetas/ensalada-de-quinoa-con-brocoli' : '/recetas/ensalada',
'/recetas/ensalada-de-quinoa-en-tarro-de-cristal' : '/recetas/ensalada',
'/recetas/ensalada-de-quinoa-y' : '/recetas/ensalada',
'/recetas/ensalada-templada-de-judias-con-boletus' : '/recetas/ensalada',
'/recetas/penne-de-lentejas-y-zanahorias-bonduelle-veggie-con-salsa-de-verduras-y-migas-crujientes' : '/recetas/verduras/zanahorias',
'/recetas/pollo-tikka-marinado-con-chutney-de-verduras-en-pan-chapati' : '/recetas',
'/recetas/pure-de-guisantes' : '/recetas/verduras/guisantes',
'/recetas/quesadillas-de-frijoles-rojos-y-maiz-con-rucula-y-mozzarela' : '/recetas/verduras/maiz',
'/recetas/receta-de-hamburguesas-vegetales-con-ensalada-de-rucula-y-brocoli' : '/recetas/ensalada',
'/recetas/remolacha-con-huevo-en-emulsion-2' : '/recetas/verduras/remolacha',
'/recetas/revuelto-de-lubina-con-guisantes-y-ajetes' : '/recetas/verduras/guisantes',
'/recetas/sopa-de-verduras-2' : '/recetas/sopa-crema',
'/recetas/strudel-de-pollo' : '/recetas',
'/recetas/tarta-de-hongos-mini-con-masa-de-hojaldre' : '/recetas',
'/recetas/yogur-con-compota-de-maiz-y-remolacha' : '/recetas/verduras/maiz',
'/responsabilidad-social-corporativa' : '/desde-1853/novedades',
'/verduras/escarola' : '/desde-1853/campo-hasta-plato',
'/blog/aguacate-propiedades-recetas-fruta' : '/blog/tendencias',
'/blog/alimentos-saludables-para-una-dieta-variada' : '/blog/tendencias',
'/blog/cocinar-verduras-5-ideas-muy-sabrosas' : '/blog/tendencias',
'/blog/cupones-bonduelle' : '/blog/tendencias',
'/blog/descubre-otra-receta-de-cristobal-de-master-chef-2-bacalao-confitado-con-crema-de-guisantes' : '/blog/tendencias',
'/blog/dulce-y-salado-sandwich-integral-con-queso-bree-y-mango' : '/blog/tendencias',
'/blog/foodies-la-nueva-tribu-de-la-cocina' : '/blog/tendencias',
'/blog/las-endivias-un-gran-alimento-para-los-ninos' : '/blog/tendencias',
'/blog/las-verduras-entre-los-mejores-alimentos-para-el-cerebro' : '/blog/tendencias',
'/blog/manten-todo-el-sabor-con-verduras-envasadas' : '/blog/tendencias',
'/blog/propuesta-de-menu-saludable-para-el-mes-de-agosto' : '/blog/tendencias',
'/blog/receta-de-empanadas-de-maiz' : '/blog/tendencias',
'/blog/recetas-de-dulces-veganos-brownie-y-helado' : '/blog/tendencias',
'/blog/recetas-saludables-3-ideas-originales' : '/blog/tendencias',
'/blog/truco-las-verduras-del-dia-anterior-como-recien-hechas' : '/blog/tendencias',
'/productos/guisantes-finos' : '/productos/p/bonduelle-natur-guisantes-finos-lata-140-g.-pack-2/03083681012927',
'/recetas/arroz-al-horno-con-soja-y-garbanzos' : '/recetas/r/arroz-al-horno-con-soja-y-garbanzos/esgp002',
'/recetas/burger-vegetal-con-tabule-de-quinoa' : '/recetas/r/burger-vegetal-con-tabule-de-quinoa/esgp083',
'/recetas/canelones-de-espinacas-rellenos-de-requeson-y-avellanas' : '/recetas/r/canelones-de-espinacas-rellenos-de-requeson-y-avellanas/esgp044',
'/recetas/champinones-bonduelle-guisados' : '/recetas/verduras/champinones',
'/recetas/crostone-con-delicias-de-tomate-queso-robiola-y-tomate-seco' : '/recetas/r/crostone-con-delicias-de-tomate-queso-robiola-y-tomate-seco/esgp076',
'/recetas/ensalada-al-aire-libre' : '/recetas/ensalada',
'/recetas/ensalada-de-fuisilli-de-maiz-y-garbanzos-de-bonduelle-veggie-con-sabores-griegos' : '/recetas/ensalada',
'/recetas/ensalada-de-guisantes-con-bacalao' : '/recetas/ensalada',
'/recetas/ensalada-de-quinoa-con-maiz-2' : '/recetas/ensalada',
'/recetas/filete-de-ternera-relleno-2' : '/recetas',
'/recetas/flan-de-espinacas-y-gambas' : '/recetas/verduras/espinacas',
'/recetas/guisantes-con-ajetes' : '/recetas/verduras/guisantes',
'/recetas/lomo-de-cordero-lechal-al-horno-albardado-con-frutos-secos' : '/recetas',
'/recetas/merluza-en-emulsion-de-mostaza-y-judias-verdes' : '/recetas/verduras/judias-verdes',
'/recetas/paella-de-verduras' : '/recetas',
'/recetas/pasta-con-verduras-bonduelle' : '/recetas',
'/recetas/pisto-manchego' : '/recetas',
'/recetas/rape-con-crema-de-patatas-y-guisantes' : '/recetas/verduras/patatas',
'/recetas/saquitos-de-atun-con-un-toque-de-maiz' : '/recetas/verduras/maiz',
'/recetas/sopa-de-maiz' : '/recetas/verduras/maiz',
'/recetas/tatin-de-piquillo-caramelizado-con-aire-de-pepino-y-lima' : '/recetas',
'/recetas/temakinsalada-de-cangrejo-zanahoria-y-aguacate' : '/recetas/verduras/aguacate',
'/recetas/timbal-de-arroz-con-verduras-crujientes' : '/recetas',
'/blog/4-ideas-para-preparar-la-cena-de-nochevieja' : '/blog/tendencias',
'/blog/4-postre-cenas-navidad' : '/blog/tendencias',
'/blog/colores-verduras' : '/blog/tendencias',
'/blog/covid-19-bonduelle-se-adapta-a-la-situacion' : '/blog/tendencias',
'/blog/divertidas-recetas-para-disfrazar-las-verduras' : '/blog/tendencias',
'/blog/gazpacho-de-remolacha-una-receta-de-cristobal-de-master-chef-2' : '/blog/tendencias',
'/blog/idea-espuma-de-lentejas-con-chorizo' : '/blog/tendencias',
'/blog/que-es-la-espelta-y-cuales-son-sus-ventajas' : '/blog/tendencias',
'/blog/receta-de-crepes-veganos' : '/blog/tendencias',
'/blog/trucos-de-cocina-para-una-deliciosa-ensalada-de-pasta' : '/recetas/ensalada',
'/productos/judias-verdes-extra-finas-copy' : '/productos/verduras/judias-verdes',
'/recetas/bomba-de-huevo-con-champinones-al-ajo-negro' : '/recetas/verduras/champinones',
'/recetas/bowl-de-delicias-de-calabaza-y-zanahoria-con-verduras-y-legumbres' : '/recetas/r/bowl-de-delicias-de-calabaza-y-zanahoria-con-verduras-y-legumbres/esgp086',
'/recetas/calamar-encebollado-con-arroz-y-guisantes' : '/recetas/verduras/guisantes',
'/recetas/canelon-xl-de-espinacas-y-setas-sobre-crema-de-maiz' : '/recetas/r/canelon-xl-de-espinacas-y-setas-sobre-crema-de-maiz/esgp084',
'/recetas/cocinero-sofisticado/page2' : '/recetas',
'/recetas/coliflor-con-bechamel-2' : '/recetas/verduras/coliflor',
'/recetas/ensalada-de-brocoli-escabechado-2' : '/recetas/ensalada',
'/recetas/ensalada-de-jamon-crujiente-guisantes-y-mozzarella-con-vinagreta-de-menta' : '/recetas/ensalada',
'/recetas/ensalada-de-judias' : '/recetas/r/ensalada-de-judias-verdes-y-patatas-con-pesto/esgp075',
'/recetas/ensalada-de-judias-con-anchoas' : '/recetas/ensalada',
'/recetas/ensalada-de-lechuga-con-un-toque-de-edamame-y-champinones' : '/recetas/verduras/edamame',
'/recetas/ensalada-de-tomate-ventresca-y-guisantes-en-escabeche' : '/recetas/ensalada',
'/recetas/flan-de-arroz-con-verduras' : '/recetas/postre',
'/recetas/gazpacho-de-remolacha' : '/recetas',
'/recetas/lazos-con-guisantes-y-falso-pesto' : '/recetas/verduras/guisantes',
'/recetas/puerros-con-bechamel-de-remolacha' : '/recetas/verduras/remolacha',
'/recetas/quinoa-con-calabaza-a-la-parrilla' : '/recetas/verduras/calabaza',
'/recetas/rigatoni-de-calabacin-y-guisantes-bonduelle-veggie-con-salsa-de-tomate-cherry-y-ricotta' : '/recetas/verduras/calabacines',
'/recetas/salteado-estilo-parisino-a-los-dos-tomates' : '/recetas/r/salteado-estilo-parisino-a-los-dos-tomates/esgp079',
'/recetas/una-original-crema-de-calabaza' : '/recetas/verduras/calabaza',
'/blog/5-ideas-cumpleanos-infantil-sano-nutritivo' : '/blog/tendencias',
'/blog/5-ideas-para-comer-sano-este-invierno-en-el-trabajo' : '/blog/tendencias',
'/blog/5-platos-5-superalimentos' : '/blog/tendencias',
'/blog/5-platos-internacionales-para-esta-navidad' : '/blog/tendencias',
'/blog/5-sopas-y-cremas-para-navidad' : '/blog/tendencias',
'/blog/especias-el-ingrediente-perfecto-para-tus-recetas-de-cocina' : '/blog/tendencias',
'/blog/espelta-anade-este-alimento-saludable-a-tus-recetas' : '/blog/tendencias',
'/blog/food-trucks-la-nueva-tendencia-culinaria' : '/blog/tendencias',
'/blog/frotar-la-manzana-con-zumo-de-limon' : '/blog/tendencias',
'/blog/la-vitamina-c-buena-para-la-salud-y-el-deporte' : '/blog/tendencias',
'/blog/los-ninos-comen-con-los-ojos' : '/blog/tendencias',
'/blog/pelar-hortalizas-cilindricas' : '/blog/tendencias',
'/blog/que-llevar-a-un-picnic-ideas-y-recetas-para-picnic-2' : '/blog/tendencias',
'/blog/receta-de-galletas-con-maicena' : '/blog/tendencias',
'/blog/recetas-de-cocina-casera-con-bonduelle' : '/blog/tendencias',
'/blog/sopa-de-remolacha-con-manzana-en-5-sencillos-pasos' : '/blog/tendencias',
'/blog/superverduras-superpoderes' : '/blog/tendencias',
'/blog/tornear-calabacin' : '/blog/tendencias',
'/productos/espinacas-milhojas' : '/productos/p/bonduelle-espinacas-milhojas-bolsa-400-g.-individual/03083681022711',
'/recetas/bacalao-crujiente-sobre-judias-verdes-con-mojo-canario-nikkei' : '/recetas/verduras/judias-verdes',
'/recetas/crema-de-guisantes-bonduelle-con-avena' : '/recetas/verduras/guisantes',
'/recetas/crema-de-judias-blancas' : '/recetas/sopa-crema',
'/recetas/crujiente-de-verduras' : '/recetas',
'/recetas/dorada-con-verduritas' : '/recetas',
'/recetas/pred-particularite/recipeVegan':'/recetas/habitos-culinarios/vegetariano',
'/recetas/pred-particularite/recipeVeggie':'/recetas/habitos-culinarios/vegano',
'/recetas/dorada-marinada-con-berenjena' : '/recetas/verduras/berengenas',
'/recetas/ensalada-de-habitas-bonduellecon-alino-de-menta' : '/recetas/ensalada',
'/recetas/ensalada-de-judias-verdes-y-patatas-con-pesto' : '/recetas/r/ensalada-de-judias-verdes-y-patatas-con-pesto/esgp075',
'/recetas/flan-de-guisantes-con-menta' : '/recetas/verduras/guisantes',
'/recetas/gazpacho-de-melon' : '/recetas/sopa-crema',
'/recetas/guisantes-salteados-con-sepia' : '/recetas/verduras/guisantes',
'/recetas/jirafa-de-maiz-con-frutas' : '/recetas/verduras/maiz',
'/recetas/milhojas-de-champinones' : '/recetas/verduras/champinones',
'/recetas/muslitos-de-pollo-de-corral-con-soja' : '/recetas',
'/recetas/penne-de-lentejas-y-zanahorias-bonduelle-veggie-con-almejas-gambas-y-calabacin' : '/recetas/verduras/calabacines',
'/recetas/postre' : '/recetas/postre',
'/recetas/risotto-con-guisantes-al-limon' : '/recetas/verduras/guisantes',
'/recetas/sopa-de-maiz-y-esparragos' : '/recetas/verduras/maiz',
'/recetas/sorbete-de-apio-2' : '/recetas/entrantes',
'/recetas/tartar-oriental-de-atun-y-maiz' : '/recetas/verduras/maiz',
'/recetas/timbal-de-judias-bonduelle-con-aceite-y-nueces' : '/recetas',
'/blog/5-combinaciones-de-alimentos-para-una-vida-sana' : '/blog/tendencias',
'/blog/5-ideas-para-que-tus-hijos-coman-mas-verdura' : '/blog/tendencias',
'/blog/cocinar-para-los-amigos-mision-imposible' : '/blog/tendencias',
'/blog/crema-de-verduras-sabor-y-sencillez-en-una-receta' : '/blog/tendencias',
'/blog/hacer-compra-vacaciones' : '/blog/tendencias',
'/blog/ideas-para-decorar-tus-platos-de-verduras' : '/blog/tendencias',
'/blog/los-zumos-de-verduras-otra-variedad-mas-para-comer-sano' : '/blog/tendencias',
'/blog/palomitas-de-maiz-snack-perfecto-picar-entre-horas' : '/blog/tendencias',
'/blog/para-tus-hijos/page7' : '/blog/tendencias',
'/blog/pimiento-con-salsa-de-naranja' : '/blog/tendencias',
'/blog/preparar-una-cena-de-nochevieja-perfecta' : '/blog/tendencias',
'/blog/que-ingredientes-nunca-puedes-incluir-en-una-ensalada' : '/recetas/ensalada',
'/blog/sabor-cremas-pures' : '/blog/tendencias',
'/blog/truco-coccion-de-la-acelga' : '/blog/tendencias',
'/productos/champinones-laminados-naturales' : '/productos',
'/recetas/amante-vegetales/page2' : '/recetas',
'/recetas/boquerones-fritos-con-verduritas' : '/recetas/r/boquerones-fritos-con-verduritas/esgp005',
'/recetas/burratina-con-salteado-estilo-mediterraneo' : '/recetas/r/burratina-con-salteado-estilo-mediterraneo/esgp080',
'/recetas/calabacines-rellenos' : '/recetas/verduras/calabacines',
'/recetas/calabacines-rellenos-con-pasta-de-guisante' : '/recetas/verduras/calabacines',
'/recetas/champinones-bonduelleen-salsa-acompanados-de-huevos-escalfados-jamon-y-rebanadas-de-pan-crujientes' : '/recetas/verduras/champinones',
'/recetas/crema-de-espinacas' : '/recetas/verduras/espinacas',
'/recetas/emperador-con-salsa-de-olivas' : '/recetas',
'/recetas/ensalada-de-pimientos-con-jamon' : '/recetas/ensalada',
'/recetas/ensalada-de-puerros-y-ternera' : '/recetas/ensalada',
'/recetas/ensalada' : '/recetas/ensalada',
'/recetas/entrecot-con-salteado-de-pimientos-del-piquillo-bonduelle-y-ajos' : '/recetas',
'/recetas/esqueixada-de-bacalla-y-crudites-bonduelle' : '/recetas',
'/recetas/fideos-chinos-con-gambas-setasmaiz-y-judias-verdes-bonduelle' : '/recetas/verduras/judias-verdes',
'/recetas/gado-gado' : '/recetas',
'/recetas/marlene-bacalao-con-brotes-de-soja-bonduelle' : '/recetas',
'/recetas/mousse-de-calabaza-langostino-y-champinon' : '/recetas/verduras/champinones',
'/recetas/mousse-de-pimientos-asados-con-coliflor' : '/recetas/verduras/coliflor',
'/recetas/penne-de-lentejas-y-zanahorias-bonduelle-veggie-con-salmon-cremoso-y-hojas-de-albahaca-fresca' : '/recetas/verduras/zanahorias',
'/recetas/receta-de-coca-de-hojaldre-con-verduras-bonduelle-natur-mozzarella-y-uvas-rojas-con-chimichurri' : '/recetas',
'/recetas/samosas-de-calabaza-y-zanahoria' : '/recetas/r/samosas-de-calabaza-y-zanahoria/esgp087',
'/recetas/taco-de-espinacas-y-gambas-con-alioli-de-chile' : '/recetas/r/taco-de-espinacas-y-gambas-con-alioli-de-chile/esgp085',
'/recetas/timbal-de-sardinas-escabechadas-con-verduras-frescas-crujientes' : '/recetas',
'/recetas/truchas-a-la-navarra-2' : '/recetas',
'/blog/10-recetas-para-incluir-espelta-y-mezcla-de-cereales-en-tus-comidas' : '/recetas/verduras/espelta',
'/blog/5-platos-de-pasta-imprescindibles-en-tu-dieta' : '/blog/tendencias',
'/blog/cocina' : '/blog/tendencias',
'/blog/cocina-diferente' : '/blog/tendencias',
'/blog/crea-ensalada-coloridas-sanas-y-deliciosas' : '/recetas/ensalada',
'/blog/descubre-la-receta-mas-dulce-de-cristobal-de-master-chef-2-tiramisu-con-falsos-mikados' : '/blog/tendencias',
'/blog/descubriendo-a-super-zanahoria' : '/blog/tendencias',
'/blog/el-calentamiento-global' : '/blog/tendencias',
'/blog/entrevista-bonduelle-cocineros-belen-paco' : '/blog/tendencias',
'/blog/flores-un-sabor-diferente-para-tu-cocina' : '/blog/tendencias',
'/blog/idea-huevo-escalfado-con-verduras-asadas' : '/blog/tendencias',
'/blog/la-pizza-y-bonduelle' : '/blog/tendencias',
'/blog/la-vitamina-a' : '/blog/tendencias',
'/blog/los-5-mejores-alimentos-para-adelgazar-este-verano' : '/blog/tendencias',
'/blog/menu-semanal-para-agosto-2016' : '/blog/tendencias',
'/blog/pautas-para-combatir-la-obesidad-infantil' : '/blog/tendencias',
'/blog/platos-variados-y-rapidos-para-estas-vacaciones' : '/blog/tendencias',
'/blog/proposito-para-2020-un-ano-mas-sostenible' : '/blog/tendencias',
'/blog/propuesta-menu-saludable-para-julio-2014' : '/blog/tendencias',
'/blog/receta-de-pastel-de-zanahoria-vegano' : '/blog/tendencias',
'/blog/recetas-con-quinoa-para-ninos' : '/blog/tendencias',
'/blog/recetas-para-tupper-las-mejores-recetas-para-llevar' : '/blog/tendencias',
'/blog/recetas-veganas-3-ideas-originales' : '/blog/tendencias',
'/blog/seguridad-alimentaria' : '/blog/tendencias',
'/blog/sopas-frias-las-sopas-tambien-son-para-el-verano' : '/blog/tendencias',
'/blog/tallar-una-sandia-para-hacerla-mas-atractiva' : '/blog/tendencias',
'/blog/utiliza-los-lichis-en-tus-postre' : '/blog/tendencias',
'/blog/utilizar-especieros-de-cristal' : '/blog/tendencias',
'/productos/en-forma-de-pepitas' : '/productos',
'/productos/salteados' : '/productos/p/bonduelle-salteado-estilo-mediterraneo-bolsa-400-g.-individual/03083681106572',
'/recetas/aperitivos-y-tapas' : '/recetas/aperitivo-tapa',
'/recetas/arroz-meloso-con-espelta' : '/recetas/verduras/espelta',
'/recetas/arroz-meloso-de-pescado' : '/recetas',
'/recetas/cocinero-sofisticado/page5' : '/recetas',
'/recetas/conejo-con-arroz-y-verduritas' : '/recetas',
'/recetas/crema-de-alcachofas-con-almejas' : '/recetas',
'/recetas/crema-de-apio' : '/recetas',
'/recetas/crema-de-maiz-bonduelle-con-cangrejo' : '/recetas/verduras/maiz',
'/recetas/ensalada-cesar-con-avellanas-y-pollo' : '/recetas/ensalada',
'/recetas/ensalada-de-berenjenas' : '/recetas/ensalada',
'/recetas/ensalada-de-garbanzos-con-comino-y-maiz-bonduelle' : '/recetas/ensalada',
'/recetas/ensalada-para-la-piscina' : '/recetas/ensalada',
'/recetas/espaguetis-con-puerros-y-guisantes-al-pesto' : '/recetas/verduras/guisantes',
'/recetas/fajita-de-maiz-con-queso-tofu-mediterraneo-y-salsa-de-yogur' : '/recetas/verduras/maiz',
'/recetas/fanatico-dieta/page4' : '/recetas',
'/recetas/flor-sana' : '/recetas',
'/recetas/milhojas-de-maiz' : '/recetas/verduras/maiz',
'/recetas/patatas' : '/recetas/recetas-por-tema/plato-principal/verduras/patatas',
'/recetas/patatas-con-sepia' : '/recetas/verduras/patatas',
'/recetas/receta-de-gusanito-de-tomates-y-hamburguesas' : '/recetas',
'/recetas/salmorejo-con-textura-de-tomate-anchoas-y-huevo-de-codorniz' : '/recetas',
'/blog/10-razones-para-comer-ensalada-de-verano' : '/recetas/ensalada',
'/blog/10-sanas-y-deliciosas-recetas-de-otono' : '/blog/tendencias',
'/blog/3-deliciosas-recetas-de-salmorejo' : '/blog/tendencias',
'/blog/3-ideas-originales-para-cenar-con-amigos-esta-semana-santa' : '/blog/tendencias',
'/blog/3-platos-para-cenar-en-familia' : '/blog/tendencias',
'/blog/3-recetas-divertidas-para-ninos' : '/blog/tendencias',
'/blog/3-recetas-navidenas-para-ninos' : '/blog/tendencias',
'/blog/5-beneficios-ensalada-verano' : '/recetas/ensalada',
'/blog/5-consejos-mantener-linea-verano' : '/blog/tendencias',
'/blog/alimentos-para-conciliar-el-sueno-en-ninos' : '/blog/tendencias',
'/blog/cascar-un-huevo-para-utilizar' : '/blog/tendencias',
'/blog/cenas-navidenas-reinventamos-las-recetas-tradicionales' : '/blog/tendencias',
'/blog/combina-verduras-platos-coloristas-ninos' : '/blog/tendencias',
'/blog/como-hacer-tortillas-de-maiz' : '/blog/tendencias',
'/blog/concurso-10000-bonduelle' : '/blog/tendencias',
'/blog/consejos-alimentacion-equilibrada' : '/blog/tendencias',
'/blog/consejos-y-trucos' : '/blog/tendencias',
'/blog/descubre-las-super-verduras-de-bonduelle-y-sus-super-poderes' : '/blog/tendencias',
'/blog/dibuja-platos-verduras-ninos' : '/blog/tendencias',
'/blog/dietas-para-adelgazar-hazlo-de-forma-saludable' : '/blog/tendencias',
'/blog/ensalada-verano-bonduelle' : '/recetas/ensalada',
'/blog/idea-cortar-judias-verdes-en-lardones' : '/blog/tendencias',
'/blog/idea-salteado-de-alubias-blancas-con-maiz-y-guisantes' : '/blog/tendencias',
'/blog/ideas-conquistar-mas-pequenos-con-verduras' : '/blog/tendencias',
'/blog/ideas-para-tus-ensalada-con-frutos-secos-y-encurtidos' : '/recetas/ensalada',
'/blog/la-ensalada-perfecta-te-contamos-como-prepararla' : '/recetas/ensalada',
'/blog/lavar-y-secar-en-papel-hierbas-frescas' : '/blog/tendencias',
'/blog/lentejas-con-quinoa' : '/blog/tendencias',
'/blog/menu-mensual-para-abril-2018' : '/blog/tendencias',
'/blog/menu-mensual-para-febrero-2017' : '/blog/tendencias',
'/blog/menu-semanal-para-mayo-2016' : '/blog/tendencias',
'/blog/nueva-receta-de-cristobal-de-master-chef-2-pulpo-a-la-gallega-siglo-xxi' : '/blog/tendencias',
'/blog/nutricion/page10' : '/blog/tendencias',
'/blog/para-ninos-nuggets-de-pollo-caseros' : '/blog/tendencias',
'/blog/picotear-entre-horas-puede-ser-saludable-apunta-estos-tres-picoteos-sanos' : '/blog/tendencias',
'/blog/por-que-llevar-una-dieta-sana-y-equilibrada' : '/blog/tendencias',
'/blog/prepara-una-sana-y-divertida-cena-de-halloween' : '/blog/tendencias',
'/blog/propuesta-menu-sano-equilibrado-enero' : '/blog/tendencias',
'/blog/quieres-vivir-una-navidad-mas-sostenible-sumate-a-la-naviduelle' : '/blog/tendencias',
'/blog/receta-de-sushi-vegetariano' : '/blog/tendencias',
'/blog/recetas-para-navidad-4-platos-gourmets-para-tus-invitados' : '/blog/tendencias',
'/blog/remedios-y-dieta-contra-el-estrenimiento-infantil' : '/blog/tendencias',
'/blog/sin-agobios-como-cocinar-mas-facil-y-rapido' : '/blog/tendencias',
'/blog/truco-acanalar-zanahoria' : '/blog/tendencias',
'/blog/verduras-a-la-plancha-5-variables-increibles' : '/blog/tendencias',
'/cenas-en-familia' : '/recetas',
'/politica-cookies' : '/cookies',
'/productos/guisantes-bio-2' : '/productos/p/bonduelle-salteado-estilo-mediterraneo-bolsa-400-g.-individual/03083681106572',
'/productos/mezclas-y-otras-verduras' : '/productos',
'/recetas/alcachofas-rellenas-con-jamon' : '/recetas/verduras/alcachofas',
'/recetas/ataditos-de-endivias-rellenos-de-mejillones-y-salsa-de-guisantes' : '/recetas/verduras/guisantes',
'/recetas/batatas-rellenas-de-estofado-de-lengua' : '/recetas',
'/recetas/bistec-con-queso-azul' : '/recetas',
'/recetas/buddha-bowl' : '/recetas',
'/recetas/bulgur-con-bonduelle' : '/recetas',
'/recetas/caballas-escabechadas-con-zanahoria-y-guisantes' : '/recetas/verduras/guisantes',
'/recetas/capas-frescas-de-ensalada' : '/recetas/ensalada',
'/recetas/dorada-con-salteado-de-judias' : '/recetas',
'/recetas/ensalada-con-queso-de-cabra' : '/recetas/ensalada',
'/recetas/ensalada-de-lentejas-calabacin-y-foie' : '/recetas/ensalada',
'/recetas/ensalada-de-primavera' : '/recetas/ensalada',
'/recetas/ensalada-infantil' : '/recetas/ensalada',
'/recetas/estofado-de-vacuno-con-verduras' : '/recetas',
'/recetas/fideos-con-calamarcitos-habas-y-guisantes' : '/recetas/verduras/habas',
'/recetas/fideua-con-mazorquitas-y-aceituna-negra' : '/recetas/verduras/aceitunas-negras',
'/recetas/garbanzos-con-bacalao-y-espinacas' : '/recetas/verduras/espinacas',
'/recetas/hamburguesa-para-ninos-con-un-toque-muy-divertido' : '/recetas',
'/recetas/hot-dog' : '/recetas',
'/recetas/pasta' : '/recetas',
'/recetas/pizzas' : '/recetas',
'/recetas/platos-tipicos-regionales' : '/recetas',
'/recetas/primeros' : '/recetas',
'/recetas/pure-de-zanahorias' : '/recetas/verduras/zanahorias',
'/recetas/rollitos-de-verdura-soja-y-ternera' : '/recetas',
'/recetas/salteado-de-presa-iberica' : '/recetas',
'/recetas/salteado-estilo-parisino-con-tortilla-de-queso-y-tomillo' : '/recetas/r/salteado-estilo-parisino-con-tortilla-de-queso-y-tomillo/esgp078',
'/recetas/sopa-de-champinones' : '/recetas/verduras/champinones',
'/recetas/sopa-fria-de-guisantes-y-berros' : '/recetas/verduras/guisantes',
'/recetas/tacos-de-ternera-con-un-toque-de-maiz' : '/recetas/verduras/maiz',
'/recetas/wrap-de-pavo-y-maiz-con-mayonesa-de-aguacate' : '/recetas/verduras/aguacate',
'/terminos-legales' : '/menciones-legales',
'/blog/5-deliciosas-recetas-de-verano-con-alcachofas' : '/blog/tendencias',
'/blog/alimentos-beneficiosos-salud-ocular-ninos' : '/blog/tendencias',
'/blog/alimentos-para-unos-huesos-sanos' : '/blog/tendencias',
'/blog/cenas-en-familia-3-recetas-con-verduras-para-sorprender-a-los-tuyos-estas-navidades-2' : '/blog/tendencias',
'/blog/cocina-diferente/page12' : '/blog/tendencias',
'/blog/comidas-del-mundo-y-bonduelle' : '/blog/tendencias',
'/blog/como-escaldar-tomates-en-4-pasos' : '/blog/tendencias',
'/blog/como-evitar-dolores-de-barriga-en-los-ninos' : '/blog/tendencias',
'/blog/concurso-octubre' : '/blog/tendencias',
'/blog/construye-las-verduras-mas-divertidas-con-este-divertido-puzzle' : '/blog/tendencias',
'/blog/crema-de-calabaza-recetas-rapidas-sencillas' : '/blog/tendencias',
'/blog/cristobal-de-master-chef-2-nos-sorprende-con-otra-receta-tatin-de-piquillo-con-aire-de-pepino-y-lima' : '/blog/tendencias',
'/blog/cuidarse-pero-no-obsesionarse' : '/blog/tendencias',
'/blog/el-cachopo-origen-y-recetas-mas-deliciosas' : '/blog/tendencias',
'/blog/emplatado-en-copa-de-cocktail' : '/blog/tendencias',
'/blog/ensalada-en-tarros-originales-y-saludables' : '/recetas/ensalada',
'/blog/ensalada-tradicionales-perfectas-para-afrontar-la-vuelta-de-navidad' : '/recetas/ensalada',
'/blog/facilitar-el-pelado-de-los-ajos' : '/blog/tendencias',
'/blog/fresh-hedonist-2/page8' : '/blog/tendencias',
'/blog/idea-dorada-con-pure-de-zanahorias' : '/blog/tendencias',
'/blog/idea-guarnecer-el-rabo-de-toro-con-frutas-salteadas' : '/blog/tendencias',
'/blog/idea-guarnecer-un-pure-de-verduras' : '/blog/tendencias',
'/blog/idea-palmito-con-zanahoria' : '/blog/tendencias',
'/blog/idea-pisto-tradicional-maiz-y-patatitas' : '/blog/tendencias',
'/blog/idea-sepia-con-maiz-y-judias-verdes' : '/recetas/verduras/judias-verdes',
'/blog/ideas-menu-vegano-facil' : '/blog/tendencias',
'/blog/ideas-para-camuflar-la-verdura-en-las-ensalada' : '/recetas/ensalada',
'/blog/ideas-para-que-los-ninos-coman-fuera-de-casa' : '/blog/tendencias',
'/blog/ingerir-muchas-bebidas-refrescantes' : '/blog/tendencias',
'/blog/la-dieta-mediterranea-variada-y-sana' : '/blog/tendencias',
'/blog/la-vuelta-al-cole-recetas-sanas-para-despues-del-verano' : '/blog/tendencias',
'/blog/los-huevos-nube-la-receta-mas-de-moda-en-instagram' : '/blog/tendencias',
'/blog/menu-mensual-para-diciembre-2016' : '/blog/tendencias',
'/blog/menu-sano-noviembre' : '/blog/tendencias',
'/blog/nutre-de-vitaminas-y-energia-a-tus-hijos-con-las-verduras' : '/blog/tendencias',
'/blog/para-que-los-ninos-coman-judias' : '/blog/tendencias',
'/blog/patatas-en-salsa-verde' : '/recetas/verduras/patatas',
'/blog/platos-comer-trabajo' : '/blog/tendencias',
'/blog/que-es-la-quinoa-te-contamos-todas-sus-caracteristicas' : '/blog/tendencias',
'/blog/quinoa-como-cocinar-este-cereal-lleno-beneficios' : '/blog/tendencias',
'/blog/rallar-la-vaina-de-vainilla' : '/blog/tendencias',
'/blog/recetas-de-tupper-buenas-baratas-y-tambien-bonitas' : '/blog/tendencias',
'/blog/recetas-semana-santa-3-platos-tradicionales' : '/blog/tendencias',
'/blog/showcooking-con-maiz-bonduelle-2' : '/blog/tendencias',
'/blog/tenir-mazorquita-de-maiz' : '/blog/tendencias',
'/blog/truco-escurrir-todo-tipo-de-verduras-de-hoja' : '/blog/tendencias',
'/blog/trucos-para-anadir-la-verdura-a-los-platos-preferidos-de-tus-hijos' : '/blog/tendencias',
'/blog/variedad-nutritiva-segun-sus-colores' : '/blog/tendencias',
'/blog/verduras-para-mantenerse-hidratado' : '/blog/tendencias',
'/productos/burger-vegetal' : '/productos/p/bonduelle-burger-vegetal-caja-360-g.-individual/03083681095616',
'/productos/champinon' : '/productos/verduras/champinones',
'/productos/judias-verdes-extrafinas-bio' : '/productos/verduras/judias-verdes',
'/recetas/amante-vegetales/page3' : '/recetas',
'/recetas/amante-vegetales/page8' : '/recetas',
'/recetas/arepa-de-delicias-de-tomate-con-tiras-de-pavo' : '/recetas/r/arepa-de-delicias-de-tomate-con-tiras-de-pavo/esgp077',
'/recetas/bacalao-al-ajoarriero' : '/recetas',
'/recetas/cocinero-sofisticado/page20' : '/recetas',
'/recetas/colchon-de-guisantes' : '/recetas/verduras/guisantes',
'/recetas/ensalada-al-estilo-bonduelle' : '/recetas/ensalada',
'/recetas/ensalada-bonduelle-con-amigas' : '/recetas/ensalada',
'/recetas/ensalada-de-pasta-3' : '/recetas/ensalada',
'/recetas/ensalada-veraniega-de-arroz' : '/recetas/ensalada',
'/recetas/ensaladilla-rota-de-guisantes' : '/recetas/verduras/guisantes',
'/recetas/estofado' : '/recetas',
'/recetas/falafels-verdes-con-lentejas' : '/recetas',
'/recetas/fuisilli-de-garbanzos-y-maiz-bonduelle-veggie-con-chips-de-remolacha-y-pesto-de-habas-y-menta-fresca' : '/recetas/verduras/maiz',
'/recetas/gratinado-de-orecchiette-con-guisantes' : '/recetas/r/gratinado-de-orecchiette-con-guisantes/esgp094',
'/recetas/huevos-con-champinones' : '/recetas/verduras/champinones',
'/recetas/legumbres' : '/recetas',
'/recetas/mini-pizzas-a-la-sarten-con-un-toque-de-champinones' : '/recetas/verduras/champinones',
'/recetas/patatas-rellenas-de-guisantes-y-habas' : '/recetas/verduras/patatas',
'/recetas/pepino-laminado-con-yogur-y-tomate-2' : '/recetas',
'/recetas/pescados-y-mariscos' : '/recetas',
'/recetas/plato-principal?page=11' : '/recetas',
'/recetas/postre-y-dulces' : '/recetas',
'/recetas/receta-de-crema-de-maiz' : '/recetas/verduras/maiz',
'/recetas/receta-de-sopa-de-tomate' : '/recetas',
'/recetas/receta-infantil-canelones-fantasma' : '/recetas',
'/recetas/salmorejo' : '/recetas',
'/recetas/sopa-de-maiz-bonduelle' : '/recetas/verduras/maiz',
'/recetas/sopas/page2' : '/recetas',
'/recetas/tomates-rellenos-de-arroz-maiz-y-brotes-bonduelle' : '/recetas/verduras/maiz',
'/recetas/verduras/page2' : '/recetas',
'/blog/emparedado-de-esparrago-y-remolacha':'/blog/novedades',
'/recetas/salmonete-relleno-en-su-caldo':'/recetas-home',
'/productos/especialidades':'/productos',
'/blog/la-dieta-mediterranea':'/blog/novedades',
'/blog/articulo/-tortilla-de-patatas-recetas-rapidas-y-deliciosas-de-este-plato-unico/1281/1281':'/blog/articulo/tortilla-de-patatas-recetas-rapidas-y-deliciosas-de-este-plato-unico/1281/1281'
};
